export default {
    "corporate": "公司計畫",
    "onboarding": {
        "goal_desc": "追蹤活動，您將可以獲得%{customPoints}，完成目標，您將可以獲得獎勵%{customPoints}。是時候開始了！您一次可以同時追求3個個人目標。",
        "sample_task": {
            "modalActivityTitle": "3個深呼吸",
            "rewards_featured_title": "特點",
            "rewards_partners_title": "合作夥伴",
            "header_description": "透過追蹤您的活動和完成任務、目標以及挑戰，您將獲得%{customPoints}。",
            "icon_text": "輕觸{icon}追蹤深呼吸。",
            "activityName": "深呼吸",
            "activityUnit": "呼吸"
        },
        "lets_get_started": "讓我們開始吧！",
        "start_description": "透過追蹤您的活動和完成任務、目標以及挑戰，您將獲得%{customPoints}。",
        "complete_and_earn": "完成並獲取",
        "did_it": "我做到了！",
        "task_complete": "任務已完成！",
        "breath_sample_task": "透過快速教程學習如何追蹤活動",
        "track_a_sample_activity": "追蹤一個樣例活動",
        "nice": "不錯！",
        "nice_one": "好樣的！",
        "nice_subtext_1": "您獲得了%{points} %{customPoints}。",
        "nice_subtext_2": "獲取%{customPoints}有助於您晉級。您每晉級一次，就可以獲得%{reward_currency}兌換很棒的禮物。",
        "nice_subtext_3": "在完成更多任務、追蹤活動和完成目標以及挑戰之後，您將可以獲得更多積分。",
        "progress_subtitle": "您的%{customPoints}和進展每隔%{frequency}重置一次。",
        "skip_for_now": "暫時跳過",
        "loadingText": "稍等，我們正在計算您的健康得分。",
        "goal_title": "設定個人化的目標",
        "swipe_for_more": "滑動查看更多",
        "skip_goals": "我現在已經設定完目標了。",
        "complete_profile": "",
        "level": "水平",
        "finish_onboarding_action": "請先完成引導流程",
        "vital_stats": {
            "height_ft": "身高（英呎）",
            "height_in": "身高（英吋）"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "您的隱私很重要"
        },
        "levels": {
            "title": "成就和獎勵",
            "tableTitle": "成就"
        },
        "initialScreen": {
            "title": "歡迎來到%{programName}，%{username}！",
            "getRewarded": "獲取%{rewardName}獎勵",
            "completeAgainst": "與您的同事相互競爭",
            "earnPoints": "透過健康活動獲取積分",
            "levelUp": "晉級，解鎖徽章"
        },
        "starterGoals": {
            "title": "選擇一個目標",
            "subtitle": "用一個新的健康習慣開啟您的健康之旅。"
        }
    },
    "healthkit_not_available": "無法連接Apple Health。在健康應用程式的來源下面，確保您至少開啟了最小的步驟權限，並且至少追蹤1個步驟。",
    "changeCover": "更改照片",
    "joiningCommunityToast": {
        "success": {
            "message": "您已成功加入%{name}",
            "title": "加入社群"
        }
    },
    "achievement_starts_date": "開始：%{date}",
    "editChallenge": "編輯%{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "選擇最多5項活動",
            "title": "您想要做什麼？",
            "noActivityTitle": "添加活動",
            "noActivityMessage": "選擇至少一項活動或類別。",
            "categoryItemDescription": "%{category}類別下的全部活動",
            "addActivityTitle": "您希望自己每%{period}做多少%{unit}{activity}？",
            "addCategoryQuantityTitle": "您希望從%{category}類別獲得多少%{customPoints}？",
            "subtitleCategories": "選擇一個類別。此類別的全部活動將計入目標。",
            "subtitleWithActivities": "已選中%{max}活動之%{num}",
            "selectCategoryMessage": "此類別的全部活動將被選中，先前選中的活動將被捨棄。",
            "addActivityTitleTotal": "您想要在%{period}進行多少%{activity}？"
        },
        "inviteDepartments": {
            "title": "邀請部門\/分部"
        },
        "inviteRegions": {
            "title": "邀請地區"
        },
        "createInvitation": {
            "selectMore": "請選擇至少2個%{entity}！"
        },
        "visibility": {
            "title": "可見性",
            "description": "%{programName}全部用戶都可以找到和加入團隊挑戰。"
        },
        "highest": {
            "name": "最多%{customPoints}勝利",
            "description": "無限制，%{customPoints}最高者摘下第一位"
        },
        "compete": {
            "individual": "作為個人參與競爭",
            "team": "作為團隊參與競爭"
        },
        "unitType": {
            "title": "選擇您完成目標的方式",
            "subtitle": "從活動或類別中進行選擇"
        },
        "category": {
            "name": "類別中的全部活動",
            "description": "例如，追蹤『運動』中的任何活動",
            "title": "選擇類別",
            "subtitle": "您要從哪個類別追蹤活動？"
        },
        "activities": {
            "name": "選定的活動",
            "description": "例如，追蹤像騎單車這樣的特定活動",
            "title": "選擇活動",
            "subtitle": "我們建議您專注於一個活動，但您可以最多添加5個活動",
            "maxModalTitle": "已選中最多活動",
            "maxModalDescription": "您可以添加最多5個活動。輕觸接受進行您選中的5個活動，或輕觸編輯以進行更改。",
            "warningModalTitle": "高難度",
            "warningModalDescription": "您在此目標下指定了許多活動要在一個時期內完成。您是否確定要設定如此具有挑戰性的一個目標？",
            "requiredPoints": "需要滿足%{period} %{challengeType}",
            "noActivitiesModalTitle": "添加活動",
            "noActivitiesModalDescription": "選擇至少一項活動。"
        },
        "categoryQuantity": {
            "title": "設定您的%{customPoints}目標",
            "subtitle": "您希望每個%{period}，從%{category}獲得多少%{customPoints}？",
            "subtitleTotal": "您希望%{period}從%{category}獲得多少%{customPoints}？",
            "text": "作為指導，30分鐘的中度運動等於大約105%{customPoints}",
            "noQuantityModalTitle": "數量",
            "noQuantityModalDescription": "輸入值",
            "defaultCategoryTitle": "當前類別"
        },
        "cancel": {
            "title": "取消創建挑戰",
            "message": "是否確定要取消創建挑戰？"
        },
        "createNew": "創建新挑戰",
        "chooseChallengeTitle": "選擇挑戰，或自行創建一個",
        "createOwn": {
            "title": "自行創建"
        },
        "frequency": {
            "title": "您會多經常達到您的目標？",
            "subtitle": "每日目標可以很好地幫助建立習慣"
        },
        "startAndDuration": {
            "title": "選擇開始日期和持續時長",
            "subtitle": "",
            "noFieldsTitle": "開始日期和持續時長",
            "noFieldsMessage": "請填入開始日期和持續時長"
        },
        "finalize": {
            "title": "查看您的新目標",
            "subtitle": "",
            "noFieldsTitle": "名稱和指導說明",
            "noFieldsMessage": "請填寫名稱和指導說明",
            "name": "我的%{frequency} %{names}目標",
            "instructionCategory": "從全部%{category}活動獲取%{points} %{customPoints} %{frequency}",
            "instructionActivities": "追蹤%{items} %{frequency}，獲取%{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "從全部%{category}活動中獲取最多%{customPoints}以贏取此競賽",
            "instructionCompetitionActivities": "從%{items}中獲取最多%{customPoints}以贏取此競賽",
            "namePlaceholder": "為您的競賽命名",
            "titleChallenge": "完成您的挑戰"
        },
        "dailyDescription": "例如，每天喝8杯水",
        "weeklyDescription": "例如，每週步行150分鐘",
        "monthlyDescription": "例如，每個月跑150千米",
        "totalDescription": "例如，單車騎行總計10,000千米",
        "title": "挑戰自己或他人？",
        "navigatorTitle": "創建挑戰",
        "me": {
            "name": "就我自己",
            "description": "向自己發起個人目標的挑戰"
        },
        "others": {
            "name": "與他人競爭",
            "description": "進行個人或團隊競爭"
        },
        "one": {
            "name": "個人",
            "description": "單獨與其他用戶完成"
        },
        "team": {
            "name": "作為團隊",
            "description": "作為團隊與其他團隊完成"
        },
        "company": {
            "name": "公司挑戰",
            "description": "創建特別競爭"
        },
        "adminItemTitle": "作為管理員，您可以創建",
        "userOrTeamTitle": "進行個人或團隊競爭？",
        "target": {
            "name": "設定待完成的目標",
            "description": "有上限的挑戰"
        },
        "typeTitle": "選擇%{challengeType}類型",
        "teamSizeTitle": "選擇每個團隊的規模",
        "teamSizeSubtitle": "團隊最小規模為%{min}人，最大規模為%{max}人。您的團隊的%{customPoints}是團隊所有成員的平均分，只有在符合最低成員人數要求的情況下，您的團隊才可獲取%{customPoints}。",
        "teamSize": {
            "noFieldsTitle": "最小和最大",
            "noFieldsMessage": "選擇團隊的最小和最大成員人數"
        },
        "companyChallengeTitle": "公司挑戰",
        "companyChallengeSubtitle": "您是管理員。您可以設定部門和其他類型的挑戰",
        "chooseDepartmentTitle": "選擇要競爭的部門 \/ 分部",
        "chooseRegionTitle": "選擇要競爭的地區",
        "goToChallenge": "前往我的挑戰",
        "additional": {
            "title": "已創建的挑戰",
            "subtitle": "讓我們開始吧！邀請他人加入。",
            "makePublicName": "將此設為公開",
            "makePublicDescription": "任何人都可加入",
            "toDirectoryName": "提交到挑戰目錄",
            "toDirectoryDescription": "大家可以創建一個像這樣的",
            "inviteTitle": "邀請參加挑戰",
            "titleGoal": "目標已創建！"
        },
        "quantityMinimum": {
            "message": "要求的最低數量是%{quantity}",
            "title": "數量不足"
        },
        "toast": {
            "success": "您的%{challengeType}已創建。"
        },
        "goToGoal": "前往我的目標",
        "navigatorTitleGoal": "創建目標",
        "quantityError": {
            "wholeNumber": "必須是整數",
            "greaterThanZero": "必須大於0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "您的健康得分透過對比您和上百萬與您同年齡段和同性別的其他人針對健康調查所提供的回答計算得出。您的得分顯示了您相對於他們的排名。您的得分將根據您在應用程式中輸入的運動、飲食和感受行為變化每月自動更新。堅持一致的目標設定和採取積極行動改善健康可以幫助提高您的健康得分。",
            "excellent": "您的健康得分高於85%與您同年齡段和同性別的其他人。",
            "very_good": "您的健康得分高於70-84%與您同年齡段和性別的其他人。",
            "good": "您的健康得分高於51-69%與您同年齡段和同性別的其他人。",
            "fair": "您的健康得分高於31-50%與您同年齡段和性別的其他人。",
            "poor": "您的健康得分低於70%與您同年齡段和同性別的其他人。不論何時開始以健康為先都不會太晚。好好利用我們的平台在您的健康之旅上高歌猛進吧！",
            "overall_result": "整體而言，您的健康得分屬於%{status}。",
            "category_result": "整體而言，您的{category}得分屬於{string}。",
            "goals": "沒有目標，您無法致勝。請設定最多3個個人目標，並為完成目標進行追蹤。隨著您逐漸改變您的生活方式，您將會看到您的分數提高。"
        },
        "reminder": {
            "title": "是時候更新您的健康調查了！",
            "updateAnswers": "更新我的回答"
        },
        "lastUpdated": "最後更新%{date}",
        "scoreDescription": {
            "part1": "您的得分是",
            "part2": "得分",
            "belowAverage": "低於平均",
            "aboveAverage": "高於平均",
            "part3": "為與您同年齡段和同性別的其他人。"
        },
        "improveScore": {
            "description": "您的得分基於您的健康調查回答和所追蹤的活動計算。您可以更新您的調查回答或設定新目標以取得提高。",
            "desc1": "您的得分沒法更高了！要保持住您日常活動的有趣性，您可以設定稍微高於您的正常能力的目標來挑戰自己，並邀請他人與您競爭以保持滿滿動力。",
            "desc2": "如果您做好了晉級準備，您現在就可以升級挑戰。設定稍微高於您的正常能力的目標來挑戰自己，並邀請他人與您競爭以保持滿滿動力。",
            "desc3": "設定個人目標和創建公開挑戰，確保自己對自己負責並保持動力。請務必選擇可以達成的目標和更小的時間框架——我們建議1週即可。",
            "desc4": "每天都動起來是很重要的。如果您在日常活動中運動量不足，您可以先從與您的能力和興趣相匹配的小目標入手。請務必選擇可以達成的目標和更小的時間框架——我們建議1週即可。"
        },
        "recommendedGoals": "推薦目標",
        "recommendedDescription": {
            "desc1": "設定最多",
            "desc2": "3個目標",
            "desc3": "以專注於改善您的健康。您目前有"
        },
        "categoryScore": "您的%{category}得分是",
        "learnMore": "瞭解更多",
        "youAreSet": "您準備好了！",
        "goalSetting": "目標設定",
        "attention": "沒有%{category}得分。",
        "move": {
            "error": "根據您的回答，您沒有運動得分。"
        },
        "eat": {
            "error": "您表示，有醫療保健專業人士告訴您，您有第2型糖尿病，並且病情沒有得到管理。"
        },
        "feel": {
            "error": "根據您的回答，您沒有感受得分。"
        },
        "survey": {
            "requiredField": "* 此字段必填"
        },
        "score_info_title": "我的得分意味著什麼",
        "company_average_info": "我的公司的平均水平",
        "demographic_average_info": "我的人口統計群體的平均水平",
        "score": "健康得分",
        "table": {
            "what_it_means": "它意味著什麼",
            "score": "得分"
        },
        "updated": "已更新",
        "label": {
            "excellent": "極好",
            "very_good": "很好",
            "good": "良好",
            "fair": "中等",
            "poor": "較差"
        },
        "activity": {
            "eat": "飲食活動1，飲食活動2，飲食活動3",
            "move": "運動活動1，運動活動2，運動活動3",
            "feel": "感受活動1，感受活動2，感受活動3"
        },
        "score_info_screen": "我的得分是如何計算的？",
        "details": "詳情",
        "activities": "活動",
        "improveCategoryScore": "提高我的%{category}得分",
        "meaning": {
            "heading": "得分計算"
        },
        "score_button": {
            "meaning": "這個得分意味著什麼？"
        },
        "improve": "查看推薦的目標",
        "score_text": {
            "demographic": "您所屬年齡段和性別的平均得分是",
            "company": "您公司的平均得分是"
        },
        "scoreHigher": "高於________平均",
        "scoreLower": "低於________平均",
        "settedGoals": {
            "noGoals": "沒有設定目標",
            "one": "設定了1個目標",
            "n": "設定了%{count}個目標"
        },
        "yourScoreIsPoor": "您的%{category}得分很低",
        "unlock": {
            "title": "解鎖您的健康得分",
            "description": "完成簡短的調查問卷，以瞭解您的整體健康相比您的人口統計群體中的其他人情況如何。"
        },
        "browseAndSet": "您可以在您的當前目標完成後瀏覽和設定新目標。",
        "excellent": {
            "desc1": "極其健康的生活方式",
            "desc2": "非常低的健康風險"
        },
        "veryGood": {
            "desc1": "非常健康的生活方式",
            "desc2": "低健康風險"
        },
        "good": {
            "desc1": "健康的生活方式",
            "desc2": "平均水平的健康風險"
        },
        "fair": {
            "desc1": "還算健康的生活方式",
            "desc2": "高於平均水平的健康風險"
        },
        "poor": {
            "desc1": "高健康風險",
            "desc2": "推薦進行更多日常運動",
            "desc3": "需要進行更多日常運動"
        },
        "calculateScore": {
            "description": "在您完成健康調查後，我們將用來自與您同年齡段和同性別的人們的數十億資料變量來對您的回答進行分析。計算時也會考慮到您在%{programName}追蹤的活動。\n \n 您的健康得分將定期更新，以便您查看它隨時間發生的變化。"
        },
        "improveYourScore": "正在提高您的分數"
    },
    "challengerCount": "%{num}挑戰者",
    "team_name": "團隊名稱",
    "syncingDeviceToast": {
        "danger": {
            "message": "啊哦……我們同步%{name}時出問題了。請重試。",
            "title": "同步"
        },
        "success": {
            "title": "同步",
            "message": "已成功同步%{name}。您的活動現在是最新狀態。"
        }
    },
    "allCompanyMembers": "全部公司成員",
    "allCompanyMembersTeam": "全部公司成員（團隊）",
    "successfullyRedeemedItemForConfirmation": "您已成功兌換此物品，確認電郵已發送到%{email}。",
    "no_all_events_placeholder": "看起來目前沒有活動可供加入。何不自己創建一個？",
    "confirmDeleteAccount": "透過輸入與您的帳戶相關聯的電子郵箱，確認刪除",
    "deleteAccount": "刪除帳戶",
    "linkAccounts": "管理連結帳戶",
    "titleSlug": {
        "icon_reward_text": "合格會員可以輕鬆透過前往我們的合作夥伴處購物，或使用他們的附加保險在Members’ Choice Advantage牙醫那裡看牙的方式獲得更多積分。",
        "icon_move_text": "追蹤像睡得更好或吃蔬菜這樣的每日健康選擇可以為您贏得「讓生活更美好」積分。",
        "icon_redeem_text": "「讓生活更美好」為照顧了自己的健康並且擁有醫院或附加保險的Medibank會員提供獎勵。",
        "icon_phone_text": "註冊並上線兌換獎勵吧，獎勵包括健康和康樂禮品卡或健康保險上的節省。",
        "wellness": "歡迎來到健康的世界",
        "goals": "達成您的目標",
        "devices": "堅持進步下去",
        "challenges": "創建挑戰",
        "celebrate": "社交健康",
        "habits": "建立健康的習慣",
        "joinChallenge": "加入挑戰",
        "getSocial": "交際起來",
        "reward": "透過讓生活更健康贏取獎勵。",
        "move": "改善飲食、運動和感受。",
        "phone": "更好的生活，更好的感受。"
    },
    "viewProgress": {
        "goal": "查看目標進展",
        "challenge": "查看挑戰進展",
        "progress": "查看進展"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "您可選擇是否輸入這些資訊，這些資訊是為了您自身的利益，並將僅您可見。"
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "本活動提供%{potentialBonusPoints}獎勵{customPoints}！"
        },
        "modal": {
            "paragraph1": "參加此活動，您將可以獲得獎勵%{pointsName}。",
            "paragraph2": "全部獎勵%{pointsName}將在活動完成後授予。對於您沒有參加的活動，您將無法獲得獎勵點數。"
        }
    },
    "EAP": {
        "contactInfo": "聯絡資訊",
        "doLater": "稍後再操作",
        "tellMore": "告訴我更多資訊",
        "contactMe": "聯絡我",
        "title": "員工和家庭援助計畫",
        "reachGoal": {
            "title": "您可以獲得幫助",
            "description": "您的員工和家庭援助計畫（EFAP）由%{providerName}提供，它提供了各種各樣的健康指導服務以幫助您達成自己的健康目標。\n \n 您希望%{providerName}聯絡您，為您提供更多資訊嗎？"
        },
        "privacyPolicy": "%{provider}隱私政策"
    },
    "HRIS": {
        "disclaimer": "此資訊自動設定，無法更改"
    },
    "settingGoals": {
        "description": "一次專注於3個推薦目標可以提高您的成功幾率。",
        "title": {
            "one": "您設定了1個目標"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "帳戶已連結不同用戶",
            "lastAccountMessage": "是否確定要刪除您上次連結的帳戶？一經刪除，您必須使用電子郵箱%{email}和新密碼登入。",
            "unlinkCorpAccountMessage": "是否確定要刪除您的公司連結帳戶？一經刪除，您必須再次使用電子郵箱%{email}登入。",
            "alreadyLinked": "帳戶已連結",
            "unlinkMessage": "是否確定要刪除已連結的帳戶？"
        },
        "sso": {
            "emailNotVerified": "您的電郵還未驗證。"
        },
        "signIn": {
            "dontHaveAccount": "沒有帳戶？",
            "enterPIN": "輸入您公司的計畫識別號碼",
            "dontKnowPIN": "不知道您的密碼？",
            "pin": "PIN",
            "register": "註冊",
            "pinDescription": "如果您不確定您的組織唯一的計畫識別號碼（PIN）是什麼，請聯絡您的計畫管理員。如果您有PIN，但難以進入下一步，請聯絡support@sproutatwork.com。",
            "keepMeTooltip": "為您的方便起見，在勾選此方框後，您的會話將保持有效30天。我們建議您在共用裝置上取消勾選此方框，並在操作完成後登出。"
        },
        "signUp": {
            "backToLogin": "返回登入",
            "termsOfService": "服務條款",
            "privacyPolicy": "隱私政策"
        },
        "createYourAccount": "創建您的帳戶",
        "setYourDetails": "設定您的詳盡資訊",
        "ModaHybridLogin": {
            "noAccessDashboard": "無權存取會員儀表板？",
            "signUpSSOButton": "透過 Moda 會員儀表板註冊",
            "noAccessDashboardWeb": "如果您無法存取會員儀表板，請使用下面的電子郵件和密碼登入。",
            "loginSSOButton": "透過 Moda 會員儀表板登入"
        }
    },
    "entityHasBeenDeleted": "%{name}已刪除",
    "track_challenge": {
        "message": {
            "manually": "手動追蹤",
            "automatically": "已透過%{appOrDeviceName}自動追蹤",
            "manuallyOrConnect": "手動追蹤或連接應用程式或裝置",
            "manuallyAndBy": "手動追蹤和透過%{appOrDeviceName}自動追蹤",
            "reconnectDevice": "需要裝置。請重新連接您的裝置",
            "manualAndAuto": "手動和自動追蹤",
            "trackedAutomatically": "已自動追蹤"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "無法註冊",
            "message": "無法從合作夥伴處檢索用戶詳情。請稍後重試"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "此%{goalName}需要用到應用程式或裝置。",
            "subTitle": "請連接應用程式或裝置"
        }
    },
    "descriptionSlug": {
        "wellness": "加入幫助您設定目標，聯絡交流和堅持進步下去的健康社群吧。",
        "goals": "告訴我們您的目標是什麼。我們將透過推薦目標幫助您達成所願。",
        "devices": "同步您的健身裝置，或記錄您的活動並保持自己朝著健康目標穩步邁進吧。",
        "challenges": "激起一些友好的競爭。創建挑戰，邀請他人加入其中，享受樂趣。",
        "celebrate": "與同事保持聯絡，共慶您的成功。",
        "habits": "追蹤健康活動以獲取積分。連接您的手機或可穿戴裝置，加速獲取積分。",
        "joinChallenge": "在友好的競爭中看一看您與同事相比表現如何。",
        "getSocial": "與同事保持聯絡，共慶您的成功。",
        "reward_text": "透過完成每日活動和個人挑戰，獲取積分。",
        "move_text": "無論是繞著街區走路，還是五分鐘正念練習，還是連續達成健康飲食成就，您都能因此獲得獎勵。",
        "phone_text": "用您的積分換取保險折扣，兌換精彩禮品，一切任由您選擇。",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "特性未啟用",
        "checkAppVersion": {
            "message": "看起來您的應用程式版本過舊了。請安裝最近更新。",
            "button": "更新%{appName}"
        },
        "noConnection": {
            "title": "無網路連接",
            "description": "您似乎沒有連接到網際網路。在沒有連接的情況下，您將無法完全地使用應用程式。",
            "button": "重試"
        },
        "uploadPhotoText": "為您的%{entityType}添加照片",
        "entities": {
            "community": "社群",
            "event": "活動",
            "team": "團隊",
            "goal": "目標",
            "challenge": "挑戰",
            "competition": "競爭"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "無法登入",
            "resetPasswordHeading": "需要重設密碼"
        },
        "signup": {
            "corporateOrOther": "不是Medibank會員？或屬於公司計畫的一部分？",
            "sign_up_here": "在此處報名",
            "errorHeading": "無法註冊",
            "areYouMedibankMember": "您是否是Medibank會員？",
            "isMedibankMember": "我是會員",
            "isNotMedibankMember": "我不是會員"
        },
        "bpidExists": "提供的電郵已關聯一個「讓生活更美好」用戶，電郵必須具有唯一性。",
        "generalError": "服務目前不可用"
    },
    "rewardsNoAvailableProducts": "當前沒有可用產品。",
    "endedGoal": {
        "timeToTrack": {
            "yes": "要追蹤，現在還有時間！",
            "no": "您的%{type}已結束"
        },
        "grace": "您的%{type}是結束了，但您有%{n} %{text}去追蹤任何被遺忘的活動",
        "notGrace": {
            "goal": "恭喜您達成目標！再接再厲，設定新目標保持自己健康下去吧。",
            "competition": "恭喜您完成挑戰！加入另一個挑戰，或自創一個挑戰，保持住滿滿的動力吧。"
        }
    },
    "appDeviceModal": {
        "defaultMessage": "連接您的裝置或應用程式，享受無縫追蹤。您的認證允許我們的技術合作伙伴「Sprout」安全地傳輸來自您的%{appDeviceTitle}帳戶的資料。"
    },
    "noTransactionsMessage": "看起來您還沒有進行過任何交易。",
    "noRedemptionsMessage": "看起來您還沒有進行過任何兌換。",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "您可以以個人或團隊的名義加入挑戰的競爭",
            "prompt": "目前沒有挑戰可加入。何不創建一個？"
        },
        "createChallengeButton": "創建挑戰"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "活動可以僅限受邀者參與，也可以向每個人開放。",
            "button": "創建活動"
        },
        "emptyEventsMessage": "目前沒有活動可加入。何不創建一個？"
    },
    "appnameLiveBetter": "讓生活更美好",
    "appnameTelus": "健康",
    "appnameUPnGo": "運動能人",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "您還沒有設定任何目標！",
            "descriptionNoSet": "透過設定一些目標提高您的健康得分。透過使用推薦目標，從目錄進行選擇或自創目標的方式快速開始。",
            "descriptionSet": "您可以設定我們專門為您推薦的目標，瀏覽完整目錄，或創建您自己的目標。",
            "action_text": "設定新目標",
            "heading_singular": "您可以再設定1個目標",
            "heading_plural": "您可以再設定%{number}個目標"
        },
        "heading": "個人目標",
        "single": "個人目標"
    },
    "settingGoal": {
        "yourGoal": "您的%{units}",
        "yourGoalDescription": "您已經上道了！以下%{units}將設定並立即開始。",
        "selectedGoals": "已選定的目標",
        "recommendedDescription": {
            "maximumSet": "您設定的目標已達到最大數量。您可以在您的當前目標完成後瀏覽和設定新目標。",
            "maximumSetTitle": "您設定了%{count}個目標"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "活動已刪除",
            "info": "出錯了。請重試。",
            "danger": "出錯了。請重試。"
        },
        "plural": {
            "success": "活動已刪除",
            "info": "出錯了。請重試。",
            "danger": "出錯了。請重試。"
        },
        "success": "活動已刪除",
        "info": "活動未刪除。請重試。",
        "danger": "活動未刪除。請重試。"
    },
    "participants": "參與者",
    "members": "成員",
    "timeSittingInformationOld": "指引建議您：\n - 盡量減少久坐的時間。\n - 盡可能多地打破長時間坐著的習慣。",
    "timeSittingInformation": {
        "title": "指引建議您：",
        "list": "- 盡量減少久坐的時間。\n - 盡可能多地打破長時間坐著的習慣。"
    },
    "activityLevelInformationOld": "指引建議：\n - 在每週的大部分時間（最好是全部時間）運動起來。\n - 每週累計進行超過150分鐘的中等強度體能活動。\n - 每週至少2天進行肌肉強化活動。",
    "activityLevelInformation": {
        "title": "指引建議：",
        "list": "- 在每週的大部分時間（最好是全部時間）運動起來。\n - 每週累計進行超過150分鐘的中等強度體能活動。\n - 每週至少2天進行肌肉強化活動。"
    },
    "viewGuidelines": "查看指引",
    "corporateAccountLink": {
        "verification": {
            "title": "驗證您的工作電子郵箱",
            "description": "您將需要驗證您的工作電子郵箱才能成功完成連結流程。請遵照已發送的指導說明，以："
        }
    },
    "invitation": {
        "findFriendsAndFamily": "找到朋友和家人",
        "findFriends&Family": "找到朋友和家人",
        "tapToAddFriendsAndFamily": "輕觸添加到朋友和家人",
        "addedFriendsAndFamily": "已添加到朋友和家人",
        "whoYouAreLookingFor": "沒看到您要找的人？",
        "inviteWithEmail": "用電郵邀請",
        "sentInvitations": "已發送邀請",
        "foundPerson": "我們找到了電郵匹配的此人",
        "youAreBoth": "你們都加入了%{entityName}",
        "youAreBothMore": "你們都加入了%{entityName}，+%{n}更多",
        "noFriendsAndFamilyAdded": "看起來您還沒有添加任何朋友或家人。",
        "sendInvitation": "發送邀請",
        "youHaveNoSentInvitations": "您還沒有發送任何邀請",
        "toast": {
            "success_title": "邀請已發送",
            "success_description": "%{invite_email}將在他們的收件箱中看到邀請",
            "danger_title": "邀請不成功",
            "danger_description": "請稍後重試"
        },
        "email": {
            "invalid_email": "請輸入有效的電子郵箱"
        },
        "inviteOthers": "邀請其他人",
        "searchForSomeone": "搜尋某人",
        "searchForOthersToInvite": "搜尋他人進行邀請",
        "programNameOnly": {
            "title": "僅限%{programName}",
            "description": "此%{entityType}僅向參加%{programName}的人員提供"
        },
        "domainCannotBeUsed": "此網域不可用於%{programName}",
        "actionSearchByEmail": "如果您無法找到您想尋找的人，您可以透過電郵邀請",
        "send": "發送",
        "addEmailToList": "添加電郵到列表",
        "toBeSent": "待發送的邀請",
        "noInvitationsToBeSent": "無邀請",
        "removeEmailConfirmation": "是否確定要將此電郵從列表移除？",
        "yes": "是",
        "no": "否",
        "foundByEmail": "我們找到了電郵匹配的此人",
        "addToFriendsAndFamily": "添加到朋友和家人",
        "alreadyAddedEmail": "您已將此電郵加入列表"
    },
    "pointsCurrencyAdditionalInfo": "您的%{points_name}和等級每隔%{period}重置一次。您追蹤到的全部活動都將計入相應時期內您的整體水平。",
    "rankLabel": "排名",
    "leaderboards": {
        "loadingLabel": "排行榜加載中……這可能需要幾分鐘——看起來大家都出來運動了！"
    },
    "feeds": {
        "emptyListHomePage": "還沒有貼文可顯示。請嘗試調整流，以展示更多貼文。",
        "viewingPostsFrom": "正在查看來自_______的貼文",
        "postActivity": "就您的活動添加評論或照片！",
        "indicatorLoader": {
            "defaultTitle": "刷新中……",
            "successfulLoadedTitle": "已同步且已刷新……"
        },
        "inapropriateTextError": {
            "message": "您的消息內容可能不適當。請嘗試使用更友好的語言。"
        },
        "postImageError": {
            "title": "抱歉，我們無法發佈此",
            "message": "您添加的圖像可能不適當。請嘗試另一個。"
        }
    },
    "syncModal": {
        "connect": {
            "title": "%{name}連接中",
            "description": "要想將您的%{name}資料連接到您的帳戶，請完成以下步驟：",
            "firstStep": "從%{storeName}下載並安裝%{appName}行動應用程式",
            "fourthStep": "選擇連接%{name}",
            "fifthStep": "按提示選擇要同步到%{appName}的健康指標並按下『完成』",
            "additionalInfo": "請注意，必須打開%{appName}才能觸發健康應用程式的同步。雖然您不需要保持應用程式打開，但同步可能需要一小時才能完成並出現在您的活動日誌上。"
        },
        "title": "%{name}同步中",
        "description": "要想將您的%{name}資料同步到您的帳戶，請完成以下步驟：",
        "steps": {
            "one": "在您的手機上登入您的%{appName}應用程式",
            "two": "打開您的個人資料下的應用程式和裝置部分",
            "three": "按下%{name}旁邊的同步按鈕",
            "iPhone": "在您的iPhone上登入您的%{appName}應用程式"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "工作帳戶",
            "message": "帳戶已成功連接"
        },
        "danger": {
            "message": "連接帳戶出錯"
        },
        "conflict": {
            "message": "帳戶已連結不同用戶"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "工作帳戶",
            "message": "帳戶已成功取消連接"
        },
        "danger": {
            "title": "連結帳戶",
            "message": "取消連接帳戶出錯"
        }
    },
    "earnMoreWithPartners": "透過合作夥伴獲取更多",
    "connectPartnersToEarnByShopping": "連接您的帳戶，並透過前往%{program_name}合作夥伴處購物獲取更多%{unit_type}。",
    "viewAllPartners": "查看全部合作夥伴",
    "myPartnerMemberships": "我的合作夥伴會員身分",
    "linkAccount": "連結會員身分",
    "linkToPartner": "連結到合作夥伴",
    "linkingError": "連結您的帳戶時出錯了。請重試。",
    "linkPending": "待連結",
    "unlinkAccount": "取消連結帳戶",
    "linkedToPartnerName": "已連結到%{partner_name}",
    "linked": "已連結",
    "permission": {
        "facebookTitle": "用Facebook註冊",
        "googleTitle": "用Google註冊",
        "facebookDescription": "在用Facebook註冊時，您需要向我們的技術合作夥伴「Sprout」授予許可，允許它訪問您的身分和創建您的%{programName}帳戶。",
        "googleDescription": "在用Google註冊時，您需要向我們的技術合作夥伴「Sprout」授予許可，允許它訪問您的身分和創建您的%{programName}帳戶。",
        "camera": {
            "title": "相機權限",
            "description": "需要相機權限來拍照。在iPhone設定中，輕觸%{appName}並打開相機。\n \n 請注意，您可能丟失任何未保存的更改。"
        },
        "notNow": "不是現在",
        "openSettings": "打開設定",
        "photos": {
            "title": "請允許訪問照片",
            "description": "這一操作將使得您可以分享來自您圖庫的照片和將照片保存到您的相冊。在iPhone設定中，輕觸%{appName}並將照片切換為讀取和寫入。\n \n 請注意，您可能丟失任何未保存的更改。"
        }
    },
    "firstNameContainsSpecialChar": "您的名字只可包含英文字母、連字號-和撇號",
    "lastNameContainsSpecialChar": "您的姓氏只可包含英文字母、連字號-和撇號'",
    "goToPartnerSite": "前往合作夥伴站點",
    "noPartnersFound": "未找到合作夥伴",
    "noLinkedPartners": "無已連結的合作夥伴",
    "noPartnersInCategory": "類別中無合作夥伴",
    "partnerAccountPendingVerification": "待驗證帳戶",
    "shopWithPartner": "前往合作夥伴處購物",
    "shopWithPartnerName": "前往%{partner_name}購物",
    "linkToPartnerName": "連結到%{partner_name}",
    "earnPartnerMembershipIdentifier": "會員身分標識符",
    "earnPartnerAccountPendingAddLink": "正在連結您的會員身分，可能需要幾天才能完成。",
    "earnPartnerAccountPendingRemoveLink": "正在取消連結您的會員身分，可能需要幾天才能完成。",
    "linkStatusUpdating": "連結狀態更新中",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "恭喜您添加了您的第一項活動！\n \n 如有意願，您還可以為今天和其他天添加更多活動。今天的活動完成後，當您",
            "description2": "沒有什麼可再追蹤時，輕觸下個螢幕。"
        },
        "listTitle": "在_______追蹤到的活動",
        "dots": {
            "tracked": "在這天追蹤到的活動",
            "added": "活動已添加，等待提交"
        },
        "trackedActivitiesFor": "%{date}追蹤到的活動",
        "activityTracking": "活動追蹤中",
        "addedPending": "已添加（等待提交）",
        "search": {
            "description1": "輕觸",
            "description2": "以查看可用的活動，或搜尋特定的活動"
        },
        "addActivity": "添加活動",
        "addAnotherActivity": "添加另一個活動"
    },
    "rewardsBalance": "%{currencyName}餘額：%{points}",
    "membershipIdentifierRequiredError": "需要您的會員身分標識符來進行連結",
    "incorrectValueInRange": "請輸入介於%{min}和%{max}之間的值",
    "joinTeam": {
        "title": "加入團隊",
        "createInsteadText": "加入或創建團隊以參加此挑戰"
    },
    "teamRank": "團隊排名",
    "teamScore": "團隊得分",
    "appsDevices": {
        "infoText": "在您添加應用程式或裝置時，我們將要求您授權我們的技術合作夥伴Sprout Wellness Solutions, Inc.訪問您的健康資料。",
        "connectModal": {
            "title": "授權",
            "paragraph1Part1": "我們將要求您授權我們的技術合作夥伴",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "訪問您的健康資料。",
            "paragraph2Desc1": "您的授權將允許",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "安全地將您的",
            "paragraph2Desc4": "資料同步到",
            "paragraph2Desc5": "，並幫助您獲得更多%{pointsName}！"
        },
        "statusAlert": {
            "connectMessage": "連接應用程式或活動追蹤裝置，讓同步和追蹤活動變得易如反掌",
            "connectAction": "連接應用程式或裝置",
            "errorMessage": "您有部分已連接的應用程式或裝置無法同步",
            "warningMessage": "您有部分已連接的應用程式或裝置可能存在連接問題",
            "errorAction": "修復此錯誤",
            "warningAction": "修復此警告",
            "syncingError": "同步錯誤",
            "syncingIssue": "同步問題"
        },
        "deviceDetails": {
            "warningMessage": "此應用程式或裝置同步出問題",
            "errorMessage": "此應用程式或裝置無法同步",
            "warningAction": "忽略警告",
            "noActivities": "在過去7天，沒有%{deviceName}活動同步到%{programName}。\n \n %{deviceName}追蹤到活動後，活動可能需要再一小時才會在這裡顯示。\n \n 如果您連接了另一個應用程式或裝置，並且其他應用程式或裝置追蹤到了更多步數，您將可以在那裡看到活動。否則，請試著斷開連接再重新連接%{deviceName}。如果您被要求認證或授予許可，請確保您啟用活動資料並且正在使用用於追蹤活動的相同帳戶進行認證。查看故障排除步驟，瞭解更多資訊。"
        },
        "troubleshooting": "故障排除",
        "deviceItem": {
            "error": "連接錯誤",
            "warning": "連接警告",
            "unableToSync": "無法同步"
        },
        "platformDevice": {
            "defaultApp": "您的裝置的默認健康應用程式是",
            "continueMore": "繼續看到更多的應用程式和裝置"
        }
    },
    "friendsAndFamily": {
        "learnMore": "更多地瞭解朋友和家人",
        "learnModal": {
            "title": "關於朋友和家人",
            "description": "在您把某人加為您的朋友和家人後，您可以選擇僅與他們分享您在%{programName}上發佈的貼文。\n \n 您也可以篩選僅看您的朋友和家人列表上的人在%{programName}向全部人或向您發佈的貼文。",
            "description_line1": "在您把某人加為您的朋友和家人後，您可以選擇僅與他們分享您在%{programName}上發佈的貼文。",
            "description_line2": "您也可以篩選僅看您的朋友和家人列表上的人在%{programName}向全部人或向您發佈的貼文。",
            "whatIconsMean": "圖標意味著什麼",
            "canAdd": "添加",
            "added": "已添加"
        },
        "searchDescription1": "搜尋您要加為朋友和家人的人。",
        "searchDescription2": "沒看到您要找的人？透過電郵邀請他們加入。",
        "friends&Family": "朋友和家人",
        "managingTour": {
            "title": "管理朋友和家人",
            "body": "如果您想要將某人從您的朋友和家人中移除，請輕觸圖標"
        },
        "removeOption": "從朋友和家人中移除",
        "inviteDescription1": "搜尋您的朋友和家人。",
        "inviteDescription2": "沒看到您要找的人？"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "您僅與朋友和家人分享的貼文將不再對%{userFirstName}可見。"
        }
    },
    "skipAll": "跳過全部",
    "smallMin": "最小",
    "eap": {
        "skipModal": {
            "title": "您確定嗎？",
            "description": "您始終可以在需要的時候從您的個人資料聯絡員工和家庭援助計畫。"
        },
        "contact": {
            "whatIsBestNumber": "您最合適的聯絡電話是多少？",
            "whatIsBestTime": "您最合適的聯絡時間是什麼時候？",
            "morning": "早上",
            "afternoon": "下午",
            "evening": "晚上",
            "additionalDetails": "有關您希望我們聯絡您的時間\/日期的額外詳盡資訊",
            "message": "在%{weekDay}致電%{phoneNumber}聯絡我。額外資訊：%{additional}",
            "description": "注意：我們強烈建議您選擇工作時間以外的時間，並選擇您可以進行私人通話的地點。請寫入您的時區。"
        },
        "phoneNumber": {
            "empty": "此字段不得為空",
            "missingDigits": "電話號碼必須包含至少4個數字"
        },
        "myEAP": "我的員工和家庭援助計畫"
    },
    "healthSurveySkipAllTitle": "跳過健康調查",
    "healthSurveySkipAllAlert": "是否確定要跳過健康調查剩下的全部問題？",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "員工和家庭援助計畫",
            "message": "請提供您的電話號碼和最佳聯絡時間"
        }
    },
    "allMyChallenges": "我的挑戰",
    "invitedChallenges": "邀請",
    "companyChallenges": "公司挑戰",
    "completedChallengesEmpty": "看上去您還沒有完成任何挑戰。",
    "myChallengesEmpty": "看上去您還沒有加入任何挑戰。",
    "allChallengesEmpty": "沒有挑戰。",
    "startsToday": "從今天開始",
    "startedDaysAgo": "從%{dayCount}天前開始",
    "startsInDays": "在%{dayCount}天後開始",
    "privacyOn": "關閉",
    "privacyOff": "開啟",
    "dashboard": {
        "viewLeaderboard": "查看排行榜",
        "timePeriodProgress": "您在此%{period}的進展",
        "howToEarn": "如何獲取積分"
    },
    "privacyChangeConfirmationMessage": "更改隱私？",
    "privacySettingsTitle": "隱私",
    "privacySettingsDescription": "您可以控制您的圖片、姓名和個人資料對其他用戶的可見性。",
    "mainLeaderBoardSettingsTitle": "?整體排行榜",
    "challengeLeaderBoardSettingsTitle": "?挑戰排行榜",
    "managePrivacySettingUrlTitle": "管理隱私設定",
    "onboardingFamilyPrivacySettingsMessageOn": "您在朋友和家人搜尋結果中可見。您可以選擇將您自己從搜尋結果中隱藏。",
    "onboardingFamilyPrivacySettingsMessageOff": "您的隱私設定目前會將您從朋友和家人搜尋結果中隱藏。",
    "challengeInvitationPrivacySettingsMessageOn": "您在挑戰邀請搜尋結果中可見。您可以選擇將您自己從搜尋結果中隱藏。",
    "challengeInvitationPrivacySettingsMessageOff": "您的隱私設定目前會將您從挑戰邀請搜尋結果中隱藏。",
    "challengeParticipationPrivacySettingsMessageOn": "您被列為此挑戰的參與者。您可以選擇將您自己從挑戰參與者中隱藏。",
    "challengeParticipationPrivacySettingsMessageOff": "您的隱私設定目前會將您從參與者列表中隱藏。",
    "communityInvitationPrivacySettingsMessageOn": "您在社群邀請搜尋結果中可見。您可以選擇將您自己從搜尋結果中隱藏。",
    "communityInvitationPrivacySettingsMessageOff": "您的隱私設定目前會將您從社群邀請搜尋結果中隱藏。",
    "communityParticipationPrivacySettingsMessageOn": "您被列為此社群的成員。您可以選擇將您自己從社群成員中隱藏。",
    "communityParticipationPrivacySettingsMessageOff": "您的隱私設定目前會將您從成員列表中隱藏。",
    "eventInvitationPrivacySettingsMessageOn": "您在活動邀請搜尋結果中可見。您可以選擇將您自己從搜尋結果中隱藏。",
    "eventInvitationPrivacySettingsMessageOff": "您的隱私設定目前會將您從活動邀請搜尋結果中隱藏。",
    "eventParticipationPrivacySettingsMessageOn": "您被列為此活動的參加者。您可以選擇將您自己從活動參加者中隱藏。",
    "eventParticipationPrivacySettingsMessageOff": "您的隱私設定目前會將您從參加者列表中隱藏。",
    "mainLeaderboardPrivacySettingsMessageOn": "您被顯示在整體排行榜上。您可以選擇隱藏自己，他人在查看整體排行榜時就無法看到您的排名、圖片和姓名。",
    "mainLeaderboardPrivacySettingsMessageOff": "您的隱私設定目前會在他人查看整體排行榜時隱藏您。",
    "challengeLeaderboardPrivacySettingsMessageOn": "您被顯示在挑戰排行榜上。您可以選擇隱藏自己，他人在查看挑戰排行榜時就無法看到您的排名、圖片和姓名。",
    "challengeLeaderboardPrivacySettingsMessageOff": "您的隱私設定目前會在他人查看挑戰排行榜時隱藏您。",
    "thumbsUpConfirmationTitle": "按讚",
    "thumbsUpConfirmationDescriptionline1": "恭喜，您就要給出您的第一個按讚和鼓勵他人了！",
    "thumbsUpConfirmationDescriptionline2": "您將被加到給此貼文按讚的人員列表裡去，其他人將可以看到您的圖片、姓名和查看您的個人資料。",
    "thumbsUpConfirmationButtonOk": "按讚",
    "commentToActionInfoTitle": "其他人可以看到什麼？",
    "commentToActionMessage": "在您評論時，其他人將可以看到您的圖片、姓名和查看您的個人資料。",
    "postToActionTitle": "誰可以看到此貼文？",
    "postToActionMessageLine1": "在您創建貼文時，您可以控制貼文對誰可見，您甚至可以讓貼文僅您可見。",
    "postToActionMessageLine2": "您與他人分享的貼文將會顯示您的圖片、姓名，其他人可以查看您的個人資料",
    "privateUsersDescriptionChallenge": "這些參與者已經從列表中隱藏自己",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n}私密",
    "privateUsersLastNamePlaceHolderChallenge": "參與者",
    "privateUsersDescriptionEvent": "這些參加者已經從列表中隱藏自己",
    "privateUsersFirstNamePlaceHolderEvent": "%{n}私密",
    "privateUsersLastNamePlaceHolderEvent": "參加者",
    "privateUsersDescriptionCommunity": "這些成員已經從列表中隱藏自己",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n}私密",
    "privateUsersLastNamePlaceHolderCommunity": "成員",
    "noPrivacySettings": "無隱私設定",
    "linkToPartnerNameWebsite": "透過%{partner_name}網站連結",
    "linkToPartnerWebsiteUrl": "合作夥伴網站URL",
    "start_end_time": "開始和結束時間：",
    "joinCreateTeamPrivacyDisclaimer": "您的圖片、姓名和個人資料將始終可見於在挑戰中查看您的團隊的任何人，即便您已經將您的隱私設定改為私密。",
    "carouselInstructions": {
        "swipe": "刷卡查看您的全部目標和挑戰。",
        "click": "點擊卡片查看您的全部目標和挑戰。"
    },
    "achieved": "已達成",
    "hours": "時數",
    "createCommunityFlow": {
        "navigatorTitle": "創建社群",
        "stepType": {
            "title": "社群可見性",
            "subTitle": "誰可以看到和加入社群？",
            "privateName": "私密",
            "publicName": "公開",
            "privateDescription": "只有您邀請的人可以看到或加入社群",
            "publicDescription": "任何人都可以看到和加入此社群"
        },
        "stepName": {
            "title": "為您的社群命名",
            "subTitle": "用可以讓人知道社群是關於什麼的名字命名您的社群。",
            "namePlaceholder": "社群名稱",
            "noFieldsTitle": "名稱",
            "noFieldsMessage": "未提供名稱"
        },
        "stepDescription": {
            "title": "關於您的社群",
            "subTitle": "告訴其他人您的社群與什麼相關。",
            "descriptionPlaceholder": "描述（可選）",
            "noFieldsTitle": "描述",
            "noFieldsMessage": "未提供描述"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "添加照片"
        },
        "stepJoin": {
            "title": "我們找到了類似的社群",
            "subTitle": "您想要加入這些社群而不是創建自己的社群嗎？"
        },
        "createNew": "創建新社群"
    },
    "challengeCard": {
        "allActivities": "_______中的全部活動",
        "category": "類別"
    },
    "myLinkedPartners": "我已連結的合作夥伴",
    "leaderboardPosition": "整體排行榜位次",
    "remainingInChallenge": "繼續留在挑戰中",
    "todays_progress": "今日進展",
    "this_weeks_progress": "本週進展",
    "this_months_progress": "本月進展",
    "achievement": "成就",
    "challengeCardHeader": {
        "challenge": "挑戰",
        "recommended_personal_goals": "推薦的個人目標",
        "personal_goal": "個人目標",
        "competition": "競爭",
        "recommended_goals": "推薦目標",
        "team_competition": "團隊競爭",
        "team": "團隊"
    },
    "MyMedibank": "我的Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "結束時間不得早於開始時間",
    "company": "公司",
    "lessThan1DayRemain": "不超過1天",
    "lessThan1HourRemain": "不超過1小時",
    "remainingToday": "今日餘下時間",
    "periodEndsDateAndTime": "時期結束於%{date}%{time}",
    "moreToGo": "_________還有%{n}%{unit}要完成",
    "reachedYourGoal": "您達成了您的目標%{period}！",
    "reachedYourGoalToday": "今天您達成了您的目標！",
    "editProfileItemCorrectRange": "請提供介於最小值%{min}和最大值%{max}之間的有效%{itemName}值",
    "invalidUrl": "無效URL",
    "activityLogChanged": {
        "success": "活動更改已保存",
        "info": "出錯了……請重試。",
        "danger": "出錯了……請重試。"
    },
    "discardAlert": {
        "createChallenge": "是否確定要捨棄此%{challengeType}？",
        "inviteByEmail": "是否確定要捨棄更改？",
        "createTeam": "是否確定要取消創建此團隊？",
        "cancel": "取消",
        "confirm": "是的，捨棄"
    },
    "entityInvalidNameError": "%{entity}的名稱僅應包含數字或字串值，且不得為空",
    "accept": "接受",
    "sync_now": "現在同步",
    "reconnect_device": "重新連接",
    "supported_activities": "已支援的活動",
    "recentlySynced_activity": "最近同步的活動",
    "noSyncedActivity_sevenDays": "過去7天沒有同步活動",
    "recentActivityLog": {
        "convertingActivityPoints": "活動同步中……",
        "activityMinuteOrTwo": "此操作可能需要一兩分鐘……",
        "noNewActivities": "未添加新活動……新活動同步可能需要一小時。"
    },
    "deleteCommunityCheckbox": "我瞭解這個操作無法撤銷",
    "createEvent": {
        "type": {
            "company": "公司活動",
            "user": "用戶活動",
            "title": "活動類型"
        },
        "privacy": "隱私（是否顯示參加者）",
        "cost": "成本",
        "associated": {
            "location": "關聯地點",
            "department": "關聯部門 \/ 分部"
        },
        "maxParticipants": "最多參與者（可選）",
        "errorMessage": {
            "limit": "不得大於%{maxValue}",
            "negative": "不得是負值",
            "selectedLocations": "請選擇一個或多個地點"
        },
        "selectLocations": "選定的地點",
        "createNew": "創建新活動"
    },
    "selected": "已選中",
    "deleteEventButton": "刪除本活動",
    "notification": {
        "priorityNotification": {
            "title": "您有未讀的重要更新",
            "subtitle": "輕觸現在閱讀",
            "subtitleWeb": "點擊現在閱讀"
        },
        "sectionTitle": {
            "priorityUnread": "未讀的重要更新",
            "all": "所有通知"
        },
        "modalTitle": "您有%{count}條重要更新",
        "priorityModalTitle": {
            "defaultTitle": "查看全部更新"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "取消%{entity} %{actionType}",
            "message": "是否確定要取消%{entity} %{actionType}？"
        },
        "action": {
            "creating": "創建中",
            "editing": "編輯中"
        },
        "type": {
            "team": "團隊",
            "community": "社群",
            "event": "活動",
            "challenge": "挑戰",
            "goal": "目標"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "設為公開？",
            "private": "設為私密？"
        },
        "modalSubtitle": {
            "public": "將此%{entityType}設為公開將讓它向所有人開放，每個人都可以發現和加入。是否確定要將此%{entityType}設為公開？",
            "private": "將此%{entityType}設為私密將關閉它，從而無人可以發現和加入它。是否確定要將此%{entityType}設為公開？"
        },
        "footerButton": {
            "makePublic": "是的，設為公開",
            "makePrivate": "是的，設為私密",
            "keepPrivate": "保持私密",
            "keepPublic": "保持公開"
        },
        "label": {
            "title": "將此設為公開%{entityType}",
            "subtitle": "每個人都能看到，任何人都可加入"
        }
    },
    "imageUploader": {
        "changeImageButton": "更改圖像"
    },
    "copyright": "版權所有© Sprout 2019",
    "samsunghealth_not_available": "無法連接Samsung Health。在健康應用程式的資料許可下面，確保您至少開啟了最小的步驟權限，並且至少追蹤1個步驟。",
    "rewardsHowDoIEarn": "我如何獲取%{currencyName}？",
    "unlockAchievements": "解鎖成就",
    "unlockAchievementsDescription": "追蹤活動，獲取%{pointsName}，解鎖等級，獲取更多%{currencyName}。輕觸每項成就，查看您需要做些什麼。",
    "myDay": "我的一天",
    "myGoalsChallengesTasks": "我的目標、挑戰和任務",
    "yourGoalsChallenges": "您的目標和挑戰",
    "mySocialStream": "社群貼文",
    "viewAllAchievements": "查看全部成就",
    "viewAllBonusChallenges": "查看全部獎勵性挑戰",
    "newVersionOfAppAvailable": "新版本可用！請重新加載此頁面",
    "noBonusChallengesToDisplay": "目前沒有獎勵性挑戰可選。",
    "bonusChallenges": "獎勵性挑戰",
    "reloadAppVersion": "重新加載",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "是否確定要刪除追蹤%{activity_name}？",
    "activity_tracker_instruction_header": "輕觸一天，追蹤當天的活動或查看已經追蹤到哪些活動。",
    "alertDashboardFunctionalityToBeAdded": "此處將添加文本，解釋說明追蹤時期是什麼時候，就和航空公司的忠誠計畫類似，用戶需要在一個日曆年內持續積累「里程」來獲得下一年的狀態。",
    "noNumberEntered": "輸入活動量",
    "feed": "流",
    "home": "首頁",
    "challenges": "挑戰",
    "explore": "探索",
    "rewards": "獎勵",
    "reward": "獎勵",
    "balance": "我的%{programName}獎勵餘額",
    "profile": "個人資料",
    "loading": "加載中……",
    "me": "我",
    "back": "返回",
    "next": "下一步",
    "skip": "跳過",
    "signup": "報名",
    "signin": "登入",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "登入到讓生活更美好",
    "signup_with_medibank": "以Medibank會員身分註冊",
    "signup_with_facebook": "用Facebook註冊",
    "signup_with_google": "用Google註冊",
    "signup_with_email": "用電郵註冊",
    "signin_with_medibank": "用My Medibank登入",
    "signin_with_facebook": "用Facebook登入",
    "signin_with_google": "用Google登入",
    "signin_with_email": "用電郵登入",
    "signup_heading": "創建帳戶",
    "not_a_medibank_member": "不是Medibank會員？",
    "keep_me_signed_in": "為我保持登入",
    "forgotpassword": "忘記密碼？",
    "emailaddress": "電子郵箱",
    "password": "密碼",
    "enterEmailAddress": "輸入您的電子郵箱",
    "enterYourPassword": "輸入您的密碼",
    "password_for_error": "密碼",
    "reset_password": "重設密碼",
    "passwordResetSuccess": "密碼已重設",
    "passwordResetEmailSent": "如果我們在系統中有匹配電郵，則密碼重設指示已經透過電郵向您發送。",
    "loginerror": "登入時出現了錯誤：",
    "logincancelled": "登入已取消",
    "part_of_corporate_program": "您是否在報名公司計畫？",
    "continue_here": "在此處繼續",
    "program_name": "計畫名稱",
    "error_provide_program_name": "請提供計畫名稱。",
    "program_not_found": "未找到計畫",
    "registration_field_email": "電郵",
    "employeeId": "員工ID",
    "registration_field_firstName": "名字",
    "registration_field_lastName": "姓氏",
    "no_first_name": "無名字",
    "no_last_name": "無姓氏",
    "registration_field_password": "新密碼",
    "no_disclaimer_available": "啊哦，我們遇到了問題……我們無法檢索您的組織的條款和條件。請在稍後重試註冊。",
    "registration_account_not_registered": "您似乎還沒有驗證您的電子郵箱。需要我們重新發送電郵嗎？",
    "resend_verification_email": "電郵驗證",
    "resend_verification_email_successful": "我們已經重新向您發送驗證電郵。",
    "resend_verification_email_unsuccessful": "啊哦，我們遇到了問題……我們無法重新發送驗證電郵。請重試。",
    "not_supported": "此貼文目前無法顯示。請稍後重試。",
    "policyAgreeError": "要繼續，請同意服務條款和隱私政策。",
    "challenge_completion_bonus": "完成獎勵",
    "me_tabs": {
        "activity": "活動",
        "bookmarks": "書籤"
    },
    "health_tab": {
        "my_health_score": "您的健康得分",
        "overall_health_score_description": "您的健康得分是",
        "health_score_explanation": "您的健康得分根據您對您的健康的回答和您的活動程度計算得出。\n \n 您的得分每個月都會根據您的活動水平更新。您可以設定和完成個人目標來提高您的健康得分。",
        "health_score_calculation_failed_onboarding": "出錯了，我們無法檢索您的健康得分。您現在可以繼續操作，一旦問題得到解決，我們將會更新您的得分。"
    },
    "track_activity": "追蹤活動",
    "track_an_activity": "追蹤活動",
    "track": "追蹤",
    "unable_to_track": "無法追蹤",
    "enter_before_track": "輸入要追蹤的活動量",
    "what_to_share": "您希望分享哪種更新？",
    "remove": "刪除",
    "activity_tracking_description": "您想要追蹤多少%{units}？",
    "excessive_submission": "哇！您就要為%{activity_name}追蹤到超過2,000 %{customPoints}了。在提交之前，您可以確認下它是否正確。",
    "on": "開啟",
    "in": "在",
    "from": "來自",
    "at": "位於",
    "no_activities": "沒有活動與您的搜尋相匹配。",
    "activity_tracking_desc": "您需要添加數字以繼續。輕觸左側的X以取消。",
    "activity_tracking_desc2": "輕觸活動任意位置進行編輯，輕觸+為目標進行快速追蹤",
    "vital_stats_title": "關於您",
    "invalid_numeric_response": "無效",
    "invalid_numeric_response_range": "此數字必須介於%{minimum}和%{maximum}之間",
    "search_placeholder": "搜尋資料庫……",
    "search_activities": "搜尋活動",
    "searching": "搜尋中……",
    "searchEmpty": "未找到匹配",
    "vital_stats_description": "向我們介紹一下您自己",
    "health_survey_questions": "健康調查問題",
    "health_survey_title": "完成健康調查",
    "health_survey_results": "健康調查結果",
    "health_survey_card_desc": "進行調查以快快瞭解您的健康狀況和設定個人化的目標。",
    "apps_devices_title": "連結應用程式和裝置",
    "apps_devices_card_desc": "同步您的應用程式和裝置，以輕鬆獲取%{customPoints}。",
    "interests_title": "興趣",
    "interests_card_desc": "告訴我們您的興趣是什麼。這有助於我們向您推薦您可能感興趣的目標和社群。",
    "interests_screen_desc": "您對什麼感興趣？",
    "health_obj_title": "健康目標",
    "health_obj_card_desc": "我們認為現在是時候設定一些目標了。一旦我們知道您的目標，我們就能夠為您提供更好的建議。別擔心，如果您的想法變了，您也能在之後透過您的個人資料輕鬆地進行變更。",
    "health_obj_screen_desc": "您希望致力於哪些領域？",
    "my_heatlh_obj": "我的健康目標",
    "health_topic_title": "健康話題",
    "health_topic_card_desc": "透過指定您的健康話題的方式，個人化您的體驗。",
    "health_topic_screen_desc": "您有興趣瞭解什麼？",
    "multi_select_check_error": "請選擇至少1項以繼續",
    "my_health_topics": "我的健康話題",
    "build_your_profile": "創建您的個人資料",
    "personalize_title": "個人化",
    "personalize_desc": "透過快速回答幾個問題，個人化您的體驗。",
    "set_goals_title": "查看推薦的目標",
    "set_goals_desc": "設定個人化的目標以開始邁向更健康的道路。",
    "set_this_goal": "設定此目標",
    "goal_set": "目標已設定",
    "required": "必填",
    "apps_devices_description": "連接健身平台，以自動獲取更多%{customPoints}。",
    "connected": "已連接",
    "num_connected": "（已連接%{numDevices}）",
    "available": "可用",
    "inProgress": "進展中……",
    "time_a_m": "上午",
    "time_p_m": "下午",
    "last_synced": "最後同步",
    "last_synced_lc": "最後同步",
    "no_connected_devices": "無已連接的裝置",
    "apps_devices_confirm_disconnect": "是否確定要取消連接",
    "button_delete": "刪除",
    "button_disconnect": "斷開連接",
    "button_cancel": "取消",
    "button_dismiss": "忽略",
    "ok": "OK",
    "waist_helper_text": "您的腰圍應該在肋骨以下測量，通常與肚臍齊平，要在站立時測量。如果不確定，請使用您的牛仔褲尺碼。",
    "apps_devices_manage": "管理我的應用程式和裝置",
    "my_apps_devices": "我的應用程式和裝置",
    "completeRegistration": "完成註冊",
    "havingTrouble": "有問題？",
    "contactUs": "聯絡support@sproutatwork.com獲取援助",
    "done": "完成",
    "brand": "Sprout",
    "cannotTrackTitle": "無法追蹤活動",
    "cannotTrackPrior": "哇。開始日期後才能追蹤活動。",
    "cannotTrackFuture": "還沒那麼快。活動只能追蹤到當天。",
    "cannotTrack": "活動無法在開始日期之前追蹤，也不能追蹤到未來日期。",
    "disclaimer": "免責聲明",
    "acceptTerms": "我接受條款和條件",
    "verificationEmailTitle": "驗證您的電郵",
    "email_not_yet_verified": "您似乎還沒有驗證您的電子郵箱。",
    "email_successfully_verified_title": "歡迎",
    "email_successfully_verified": "您已成功驗證您的電郵",
    "pleaseVerifyEmailMessage1": "您將需要驗證您的電子郵箱以繼續。",
    "pleaseVerifyEmailMessage2": "請遵照已發送的指導說明，以：",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "重新發送電郵",
    "restart": "返回登入",
    "firstName": "名字",
    "firstNamePlaceholder": "您的名字",
    "lastName": "姓氏",
    "lastNamePlaceholder": "您的姓氏",
    "email": "電郵",
    "emailPlaceholder": "您的電子郵箱",
    "employeId": "員工ID",
    "employeIdPlaceholder": "公司員工ID",
    "passwordPlaceholder": "新密碼",
    "datePickerTitle": "選擇您的出生日期",
    "datePickerConfirm": "確認",
    "datePickerCancel": "取消",
    "termsOfUsePrivacyPreLinks": "我同意",
    "sendMePromoCommunications": "向我發送促銷性的通訊",
    "sendMePromoCommunicationsFromPartners": "向我發送來自合作夥伴的促銷性的通訊",
    "termsOfService": "服務條款",
    "legal": "法務",
    "privacyPolicy": "隱私政策",
    "and": "和",
    "programDomainLabel": "計畫名稱",
    "programDomainPlaceholder": "計畫名稱",
    "findProgramName": "找到我的計畫名稱",
    "findProgramNameButton": "找到計畫名稱",
    "findProgramNameTitle": "找到我的計畫名稱",
    "findProgramNameDescription": "公司電子郵箱",
    "findProgramNamePlaceholder": "電子郵箱",
    "findProgramSuccessMessage": "計畫名稱的搜尋結果已透過電郵發送給您。",
    "findProgramSuccessTitle": "計畫名稱",
    "findProgramErrorTitle": "計畫名稱",
    "findProgramErrorMessage": "啊哦，我們遇到了問題……我們在嘗試檢索您的計畫名稱時遇到了錯誤。請重試。",
    "countryLabel": "選擇所在國家",
    "countryName": "所在國家",
    "regionLabel": "選擇所在地區",
    "regionName": "所在地區",
    "cityLabel": "選擇所在城市",
    "cityName": "所在城市",
    "locationWorkLabel": "選擇所在地點",
    "locationWorkName": "所在地點",
    "locationLabel": "選擇所在地點",
    "locationName": "所在地點",
    "departmentLabel": "選擇部門 \/ 分部",
    "departmentName": "部門 \/ 分部",
    "no_department": "無部門 \/ 分部",
    "enterPIN": "請輸入您的公司PIN",
    "verifyEmailTitle": "電郵驗證",
    "verifyEmailMsg": "您似乎還沒有驗證您的電子郵箱",
    "resendEmailTitle": "電郵驗證",
    "resendEmailMsg": "已重新發送到%{userEmail}",
    "select_date": "選擇日期",
    "changePasswordTitle": "更改密碼",
    "currentPassword": "當前密碼",
    "newPassword": "新密碼",
    "confirmNewPassword": "確認新密碼",
    "passwordChangeError": {
        "currentPasswordMissing": "輸入您的當前密碼",
        "newPasswordMissing": "輸入您的新密碼",
        "confirmPasswordMissing": "確認您的新密碼",
        "passwordsMatch": "密碼不匹配",
        "passwordIncorrect": "密碼錯誤。請重試。"
    },
    "settings": "設定",
    "signOut": "登出",
    "updateApp": "更新應用程式",
    "updateAppRight": "當前：%{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "獲取幫助",
    "feedback": "回饋意見",
    "feedback_success_title": "回饋意見已提交",
    "feedback_success_msg": "謝謝提交回饋意見，非常感謝您！",
    "feedback_failure_title": "錯誤",
    "feedback_failure_msg": "糟糕……提交您的回饋意見時出錯了，請重試。",
    "submit": "提交",
    "feedback_char_limit": "您已超出字符限制。",
    "feedback_char_limit_toast_title": "消息過長",
    "feedback_char_limit_toast_msg": "您的消息超出了最大2000字符的限制。",
    "feedback_char_length_msg_1": "您已鍵入",
    "feedback_char_length_msg_2": "\/2000字符。",
    "feedback_empty_toast_title": "消息為空",
    "feedback_empty_toast_msg": "看上去您還沒有鍵入任何。鍵入消息再提交。",
    "feedback_email_message": "消息：",
    "feedback_email_user_id": "，用戶ID：",
    "feedback_email_device": "，裝置：",
    "feedback_email_os_version": "，作業系統版本：",
    "feedback_email_app_version": "，應用程式版本：",
    "savingUserToast": {
        "success": {
            "title": "保存更改",
            "message": "個人資料更改已保存"
        },
        "danger": {
            "title": "遇到錯誤",
            "message": "啊哦……我們在嘗試保存您的更改時遇到了錯誤，請重試。"
        }
    },
    "edit_profile_user_error_msg": "在嘗試保存您的更改之前，請查看錯誤",
    "edit_profile_location_error": "您需要指明您的地點",
    "edit_profile_department_error": "您需要指明您的部門 \/ 分部",
    "edit_profile_unspecified_value": "您需要指明一個值",
    "edit_profile_value_too_low": "值必須大於",
    "edit_profile_value_too_high": "值必須小於",
    "choose_gender": "選擇性別",
    "activity_tracked_successfuly": "您的活動正在追蹤中",
    "multi_activity_tracked_successfully": "您的活動正在追蹤中",
    "no_activities_tracked": "沒有追蹤到活動",
    "track_activity_to_submit": "在日曆上選擇日期追蹤活動",
    "last_day": "最後",
    "days_remaining": "剩餘天數",
    "day_remaining": "剩餘天",
    "days_remaining_this_week": "本週剩餘天數",
    "day_remaining_this_week": "本週剩餘天",
    "days_remaining_this_month": "本月剩餘天數",
    "day_remaining_this_month": "本月剩餘天",
    "earned_today": "今日獲得",
    "earned_this_week": "本週獲得",
    "earned_this_month": "本月獲得",
    "earned_in_total": "總計獲得",
    "goal_completed": "目標已完成，",
    "see_results": "查看結果",
    "pts": "%{customPoints}",
    "of": "____之",
    "daily_goal": "每日目標",
    "weekly_goal": "每週目標",
    "monthly_goal": "每月目標",
    "total_goal": "總體目標",
    "weeks": "週",
    "today": "今天",
    "this_week": "本週",
    "this_month": "本月",
    "overall": "整體",
    "level": "水平",
    "days_remaining_in_period": "剩餘%{remainingDays}天",
    "days_left_in_period": "追蹤剩餘%{remainingDays}天",
    "pointsToLevel": "%{levelName}的進展",
    "levelCompleted": "%{levelName}已完成",
    "keepTrackingUntil": "繼續追蹤，直至",
    "activityLevelTitle": "我的活動水平",
    "activityLevelDescription": "您在一週中通常花多少時間保持至少中度活躍——這指的是您充分運動以提高您的心率和出汗？",
    "activityLevelUnder60": "不超過60分鐘",
    "activityLevelUnder150": "60到150分鐘",
    "activityLevelOver150": "超過150分鐘",
    "gender_male": "男性",
    "gender_female": "女性",
    "gender_rather_not_say": "不願作答",
    "date_of_birth": "出生日期",
    "height": "身高",
    "Height": "身高",
    "weight": "體重",
    "waistCircumference": "腰圍",
    "bloodPressureHg": "收縮壓",
    "bloodPressureMm": "舒張壓",
    "bloodCholesterol": "總血膽固醇",
    "ldl": "低密度脂蛋白（LDL）",
    "hdl": "高密度脂蛋白（HDL）",
    "restingHeartRate": "靜止心率",
    "percentageBodyFat": "體脂率",
    "hipCircumference": "臀圍",
    "bloodGlucose": "血糖",
    "triglycerides": "三酸甘油脂",
    "error_401_signed_out_message": "您的會話已過期。請再次登入。",
    "first_name": "名字",
    "last_name": "姓氏",
    "preferred_name": "偏好名稱",
    "notifications": "通知",
    "notificationsMarkAllReadButton": "將全部通知標記為已讀",
    "notificationsSettingsButton": "設定",
    "notificationsSettingsTitle": "通知和電郵",
    "notificationEmptyMessage": "您已看到最新消息",
    "priorityModalTitle": "我的優先通知",
    "remindMeLater": "稍後提醒我",
    "priorityAdminTitle": "來自您的管理員的通知",
    "markAsRead": "標記為已讀",
    "expand": "輕觸以展開",
    "collapse": "輕觸以折疊",
    "takePhoto": "拍攝新照片",
    "choosePhoto": "選擇照片",
    "deletePhoto": "刪除照片",
    "profileImageChangeErrorTitle": "遇到錯誤",
    "profileImageChangeErrorMessage": "啊哦……編輯您的照片時出錯了。請重試。",
    "editProfile": "編輯個人資料",
    "postButton": "發佈",
    "shareYourDayName": "您最近在忙些什麼？",
    "greeting": "哈嘍，%{firstNameDisplay}！",
    "shareAnUpdate": "您最近在忙些什麼？",
    "shareYourDaySubtitle": "您最近在忙些什麼？",
    "shareAPost": "分享貼文",
    "postVisibleTo": "對______________可見",
    "link": "連結",
    "photo": "照片",
    "insertLink": "在您的貼文中添加連結",
    "save": "保存",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "在提交之前，您需要向您的貼文添加內容。",
    "generalErrorTitle": "貼文為空",
    "generalSuccessTitle": "成功",
    "simplePlaceholder": "您最近在忙些什麼？",
    "likesCountLabel": "按讚",
    "likesReceivedLabel": "您收到的按讚",
    "commentsCountLabel": "評論",
    "commentsCountLabelSingular": "評論",
    "likeButton": "按讚",
    "commentButton": "評論",
    "seePreviousComments": "查看先前的評論",
    "addCommentPlaceholder": "添加評論",
    "postCommentButton": "發佈",
    "seeMoreLongComment": "查看更多",
    "activityPoints": "%{customPoints}",
    "activityLog": "活動日誌",
    "discardPost": "捨棄",
    "discardPostMessage": "是否確定要捨棄您的貼文？",
    "stream_filter_title": "流",
    "stream_filter_screen_desc": "選擇您想要在流中查看的貼文",
    "stream_filter_selection": "顯示：",
    "moderate": "標記為不適當",
    "moderateDescription": "標記此項為不適當將刪除此項，管理員將會收到通知。",
    "editPost": "編輯貼文",
    "deletePost": "刪除貼文",
    "deleteComment": "刪除評論",
    "editComment": "編輯評論",
    "visibleOnlyToMe": "僅對您可見",
    "joinEvent": "活動的回覆請柬",
    "joinEventDetail": "加入活動",
    "joinedEvent": "我要去",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "您已加入活動",
            "message": "您已成功加入此活動"
        }
    },
    "joinChallenge": "加入挑戰",
    "viewChallenge": "查看挑戰",
    "joinedChallenge": "已加入挑戰",
    "joinCommunity": "加入社群",
    "joinedCommunity": "已加入社群",
    "joinProgress": "加入中",
    "joinSuccess": "已加入",
    "invitePeopleToCommunity": "邀請他人加入社群",
    "numberOfMembers": "%{num}個成員",
    "joinToView": "加入此社群，以查看和向其他成員發佈貼文",
    "numberOfAttendees": "%{num}個參加者",
    "numberOfParticipants": "%{num}個參與者",
    "numberOfMembersWithUser": "您和%{num}個其他成員",
    "numberOfAttendeesWithUser": "您和%{num}個其他參加者",
    "numberOfParticipantsWithUser": "您和%{num}個其他參與者",
    "communityMembers": "%{numberOfMembers}個成員",
    "communityEvents": "%{numberOfEvents}個即將到來的活動",
    "myEvents": "我的活動",
    "seeAll": "看全部",
    "noUpcomingEvents": "無即將到來的活動。讓我們加入一個！",
    "myCommunities": "我的社群",
    "invitedCommunities": "已邀請",
    "invitationSendingMessage": "邀請發送中……",
    "invitationReceivedMessage": "已邀請您加入此",
    "invitationMessage": "我們很希望您能加入我們的社群！",
    "recommendedCommunities": "為您推薦",
    "leaveCommunity": "離開此社群",
    "leaveTeam": "是否確定要離開此挑戰中的",
    "leaveTeamLastMember": "團隊？作為團隊的最後成員，離開挑戰將會導致刪除團隊。",
    "leaveTeamChallenge": "團隊？",
    "Oops": "糟糕，出錯了",
    "editCommunity": "編輯社群",
    "deleteCommunity": "刪除此社群",
    "leaveCommunityDescription": "是否確定要離開此社群？",
    "inviteToCommunity": "邀請加入社群",
    "inviteByMembers": "按名字邀請",
    "inviteByEmail": "透過電郵邀請",
    "select_person": "請選擇至少一個受邀請人",
    "no_users_found": "嗯……我們好像找不到叫這個名字的任何人。",
    "promptJoinCommunities": "看起來您還沒有加入任何社群。加入社群，與他人交流，分享您的旅程。",
    "exploreCommunities": "探索社群",
    "sendInviteByMembers": "邀請%{num}人",
    "sendInviteByEmail": "發送電郵邀請",
    "createNewCommunity": "創建新社群",
    "createCommunity": "創建社群",
    "uploadCover": "添加照片",
    "cover": "封面",
    "nameOfCommunity": "社群名稱",
    "whatCommunityAbout": "這個社群關於什麼？",
    "companyMembersOnly": "僅限公司成員",
    "viewAllButton": "查看全部",
    "communities": "社群",
    "contentLibrary": "資料庫",
    "events": "活動",
    "past_events": "過去的活動",
    "invitationCommunity": "社群",
    "searchPeople": "搜尋人",
    "enterEmail": "輸入電郵",
    "personalMessageToNewInvitees": "給新受邀者的個人消息",
    "dangerToastTitle": "錯誤",
    "dangerToastMessage": "嗯……出錯了。請重試。",
    "successToastTitle": "成功",
    "successToastMessage": "已完成的行動",
    "joiningToast": {
        "success": {
            "message": "您加入了"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "評論已刪除"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "評論已標記為不適當"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "評論已更新"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "評論已更新"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "個人頭像已更新"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "照片已刪除"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "發佈到流中",
            "message": "您的貼文已創建"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "編輯貼文",
            "message": "您的貼文已編輯"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "刪除貼文",
            "message": "您的貼文已刪除"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "標記為不適當",
            "message": "貼文已標記為不適當"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "標記為已讀",
            "message": "所有通知已標記為已讀"
        },
        "info": {
            "title": "標記為已讀",
            "message": "所有通知均已標記為已讀。"
        },
        "danger": {
            "title": "標記為已讀"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "無法標記通知為已讀"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "密碼已更新",
            "message": "使用您的新密碼登入"
        },
        "danger": {
            "title": "更新密碼",
            "message": "啊哦……我們在嘗試更新您的密碼時出錯了。請重試。"
        }
    },
    "joining": {
        "success": {
            "message": "您加入了%{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "邀請",
            "message": "邀請已發送"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "創建社群",
            "message": "您的新社群已創建"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "您的目標已重新開始"
        },
        "danger": {
            "message": "無法重新開始目標"
        }
    },
    "quit": "退出",
    "wellbeing_survey_completed": "健康調查已完成",
    "wellbeing_survey_completed_message": "感謝您完成調查。我們希望它幫助您深入瞭解了您的健康狀況。",
    "update_wellbeing_score": "更新我的調查回答",
    "get_wellbeing_score": "獲取您的健康得分",
    "stats": "統計資料",
    "my_wellbeing_score": "我的健康得分",
    "see_details": "查看詳情",
    "how_score_calculated": "我的得分是如何計算的？",
    "contentTitle": "資料庫",
    "promoted": "特點",
    "recommended": "推薦",
    "recommendedForMe": "為我推薦",
    "recent": "最近添加",
    "view": "查看",
    "added": "已添加",
    "more": "更多",
    "openLibrary": "帶我去資料庫",
    "readToEarn": "閱讀以獲取",
    "readArticle": "打開連結",
    "see_more": "查看更多（%{num}）",
    "see_more_activities": "加%{num}",
    "my_achievements": "我的成就",
    "achievements": "成就",
    "achievement_earned_date": "已獲得：%{date}",
    "achievement_start_date": "已開始：%{date}",
    "achievement_end_date": "結束：%{date}",
    "achievement_earned": "已獲得",
    "achievement_start": "開始",
    "achievement_end": "結束",
    "achievement_earned_times": "%{num}次",
    "achievement_earned_time": "%{num}次",
    "in_progress": "進展中",
    "date_earned": "獲得日期",
    "earned": "已獲得",
    "past_dates_earned_heading": "過去獲得的日期",
    "all": "全部",
    "eat": "飲食",
    "move": "運動",
    "feel": "感受",
    "profile_completion": "個人資料完成度：%{percentage}%",
    "complete_my_profile": "完善您的個人資料",
    "do_following_tasks": "進行以下%{num}任務以完善您的個人資料。",
    "improve_my_score": "提高您的分數",
    "see_which_goals": "查看您為改善飲食、運動和感受而設定的目標。",
    "havent_set_goal": "您還未設定目標。",
    "set_a_goal": "設定目標",
    "set_another_goal": "設定另一個目標",
    "set_another_goal_here": "在此處設定另一個目標。",
    "my_recently_tracked_activities": "我最近的活動",
    "a_few_seconds_ago": "幾秒鐘前",
    "a_day_ago": "一天前",
    "yesterday": "昨天",
    "earn": "獲得",
    "delete_activity_confirmation": "是否確定要移除此活動？",
    "delete_activity_title": "移除%{activity_name}%{measurement}？",
    "reached_daily_goal": "今天您完成了您的目標。做得好！",
    "multiple_activity_non_daily_instruction": "輕觸活動行以開始追蹤和獲取%{customPoints}！",
    "multiple_activity_daily_instruction": "輕觸加號以追蹤達成您的目標所需的活動量。輕觸活動行的任意位置以追蹤相應活動的任意活動量。",
    "only_automatic_activities": "為達成此目標所計入的活動僅可自動追蹤",
    "only_automatic_activity": "為達成此目標所計入的活動僅可自動追蹤",
    "earn_pts_and_reach_goal": "透過追蹤%{qty}獲得%{pts}分並達成您的目標",
    "earn_pts_for_every": "每追蹤_________獲得%{pts}",
    "you_track": "分！",
    "you_have_tracked": "您已追蹤%{qty}",
    "so_far": "目前為止！",
    "start_goal": "設定此目標",
    "about_this_goal": "關於此目標",
    "start_date": "開始日期",
    "end_date": "結束日期",
    "activities": "活動",
    "goal": "目標",
    "instructions": "指導說明",
    "daily": "每日",
    "weekly": "每週",
    "monthly": "每月",
    "total": "總計",
    "week": "週",
    "day": "天",
    "days": "天",
    "month": "月",
    "months": "月",
    "progress": "進展",
    "about": "關於",
    "days_remaining_to_track": "您有%{num}天可以追蹤任何錯過的活動",
    "number_days": "%{num}天",
    "one_day": "1天",
    "points_earned_this_week": "本週獲得的積分",
    "points_earned_year": "年初至今獲得的積分",
    "completed": "已完成",
    "what_you_need_to_do": "您需要做什麼",
    "see_all_num": "查看全部%{num}",
    "my_week_progress": "您的每週進展",
    "my_day_progress": "您的每日進展",
    "my_month_progress": "您的每月進展",
    "my_total_progress": "您的總進展",
    "my_overall_progress": "整體進展",
    "you_earned": "您已獲得",
    "of_this_week": "本週_____%{num}之______",
    "of_this_day": "今日_____%{num}之______",
    "of_this_month": "本月_____%{num}之______",
    "of_this_total": "總計_____%{num}之______",
    "of_this_overall": "整體_____%{num}之______",
    "remaining_this_week": "本週剩餘",
    "remaining_this_month": "本月剩餘",
    "remaining_this_total": "剩餘",
    "remaining_this_overall": "整體剩餘",
    "view_history": "查看歷史",
    "this_goal_is": "此目標是",
    "will_run_for": "將長達",
    "button_unset_goal": "取消設定目標",
    "button_leave_challenge": "離開挑戰",
    "leaveChallenge": {
        "menu": "離開%{challengeName}"
    },
    "deleteChallenge": {
        "menu": "刪除%{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已取消設定此個人目標。"
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已離開挑戰。"
        }
    },
    "activities_tracked": "追蹤到的活動",
    "recently_tracked_activities": "最近追蹤到的活動",
    "add": "添加",
    "change_before_track": "看起來您還沒有做出任何更改。編輯這一天的活動數量，或不進行更改就退出。",
    "havent_tracked_today": "看起來您還沒有為這一天追蹤到任何活動。從搜尋活動開始吧。",
    "cancel_tracking_quantity": "取消追蹤%{quantity}的%{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "退出將會捨棄對您的活動歷史的編輯。您確定嗎？",
    "discard_activity_edits_confirmation_date": "退出將會捨棄對您%{date}活動歷史的編輯。您確定嗎？",
    "yes_discard_edits": "是的，退出並捨棄編輯",
    "createGoal": {
        "navigatorTitle": "創建個人目標",
        "navigatorSubtitle": "4步之%{step}步"
    },
    "allCommunities": "所有事",
    "deleteCommunityDescription": "是否確定要刪除此社群？",
    "remaining": "剩餘",
    "recommended_goal": "推薦目標",
    "pinError": "PIN%{pin}無效。請重試。",
    "previousPersonalGoals": "我已完成的個人目標",
    "previousGoalsTitle": "我先前的目標",
    "endedOn": "於______結束",
    "achievedOfGoal": "您達成了%{num}%目標",
    "previousGoalsEmptyMessage": "您沒有先前目標",
    "emptyListDefaultMessage": "您此處沒有項目",
    "myCommunitiesEmpty": "看起來您還沒有加入任何社群。加入社群，與他人交流，分享您的旅程。",
    "discoverMoreCommunities": "發現更多社群",
    "howLong": "時長",
    "frequency": "頻率",
    "discard": "捨棄",
    "description": "描述",
    "optional": "可選",
    "instruction": "指導說明",
    "name": "名稱",
    "create": "創建",
    "categories": "類別",
    "uploadPhoto": "添加照片",
    "delete_goal": "刪除此%{name}",
    "delete_goal_confirmation": "是否確定要刪除此目標？",
    "leave_goal_confirmation": "是否確定要離開此挑戰？",
    "creatingCustomGoalToast": {
        "success": {
            "message": "您的目標已創建。"
        }
    },
    "defaultSelectMessage": "請選擇一個選項",
    "search": "搜尋",
    "inTotal": "總計",
    "State": "所在州",
    "Business unit": "業務單元",
    "Work location": "工作地點",
    "whenStart": "您想要何時開始？",
    "every": "每個",
    "acceptChallenge": "接受挑戰",
    "activity_history_challenge": "挑戰的活動歷史",
    "havent_tracked_challenge": "您還沒有為此挑戰追蹤到任何活動",
    "earned_lowercase": "已獲得",
    "noone_tracked_yet": "還沒有人追蹤任何活動。開始追蹤，領先此競爭！",
    "you": "您",
    "your_team": "我的團隊",
    "congrats_first_place": "恭喜，您摘得第一位！再接再厲。",
    "leader": "領先者",
    "average": "平均",
    "show_leader": "顯示領先者",
    "show_me": "顯示我",
    "show_my_team": "顯示我的團隊",
    "leaderboard": "排行榜",
    "my_team": "我的團隊",
    "remaining_to_track": "剩餘待追蹤",
    "avg": "平均",
    "invite": "邀請",
    "team_members": "團隊成員",
    "daysLeft": "剩餘天數",
    "regionNameLiveBetter": "所在州",
    "locationNameLiveBetter": "工作地點",
    "departmentNameLiveBetter": "業務單元",
    "regionLabelLiveBetter": "選擇所在州",
    "locationLabelLiveBetter": "選擇工作地點",
    "departmentLabelLiveBetter": "選擇業務單元",
    "companyLocation": "工作地點",
    "no_location": "無地點",
    "connect": "連接",
    "syncing": "同步中",
    "sync": "同步",
    "havent_tracked_in_a_while": "無最近追蹤的活動",
    "contact": "聯絡",
    "manage": "管理",
    "creator": "創建人",
    "allow_notifications": "管理通知",
    "enable_notifications": "打開通知",
    "appload": "稍等，{app_name}正在更新……",
    "sendResetEmail": "發送重設電郵",
    "min": "最小",
    "max": "最大",
    "error_joining_team": "無法加入團隊",
    "cannot_add_to_team": "啊哦……我們在嘗試將您加入此團隊時出錯了。這可能是因為此團隊已達到最大成員人數，或團隊不再存在。如果發生了其他錯誤，請重試。",
    "members_needed": "需要%{num}個成員",
    "member_needed": "需要%{num}個成員",
    "spots_left": "還剩%{num}個名額",
    "join": "加入",
    "no_teams_create": "目前沒有任何團隊可供您加入。何不自己創建一個？",
    "number_teams": "%{num}個團隊",
    "youLowercase": "您",
    "joined_challenge_on_team": "您已加入團隊%{team_name}的挑戰。",
    "join_team": "加入團隊",
    "former_members": "前成員",
    "letsGo": "開始吧",
    "invite_to_team": "邀請加入團隊",
    "connectingDeviceToast": {
        "success": {
            "title": "連接應用程式或裝置",
            "message": "成功！您的應用程式或裝置已連接。"
        },
        "danger": {
            "title": "連接應用程式或裝置",
            "message": "啊哦……我們連接此服務時出問題了。請重試。"
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "取消連接應用程式或裝置",
            "message": "您已成功取消連接%{name}。"
        },
        "danger": {
            "title": "取消連接應用程式或裝置",
            "message": "啊哦……我們取消連接%{name}時出問題了。請重試。"
        }
    },
    "leave_entity_question": "離開%{name}？",
    "delete_entity_question": "刪除%{name}？",
    "leave_team_challenge_confirmation": "是否確定要離開參加此挑戰的%{name}？",
    "leave_last_team_member": "作為團隊的最後成員，離開此挑戰將會導致刪除團隊。",
    "oops_msg": "啊哦……嘗試完成此操作時出錯了。請重試。",
    "has_been_created": "您已加入團隊%{name}的挑戰。",
    "specify_team_name": "請註明團隊名稱",
    "invite_members": "邀請成員",
    "upload_photo_no_question": "添加照片",
    "my_progress": "我的進展",
    "rewardsPointsAdditionalInfo": "每%{period}每達到一級獲取%{reward_currency}。您的%{customPoints}和等級每隔%{period}重置一次，因此，即便您在上一期已經達到了最高等級，您也有機會繼續獲取%{reward_currency}。",
    "rewardsPointsInfo": "您的%{customPoints}和進展每隔%{period}重設一次。",
    "departments": "部門 \/ 分部",
    "regions": "地區",
    "noItemsSelected": "未選中項目",
    "pleaseSelectOne": "請從列表中至少選擇一項",
    "tracked": "已追蹤",
    "starts": "開始",
    "duration": "時長",
    "bonus": "獎勵",
    "invited_by": "邀請人",
    "create_team": "創建團隊",
    "discardConfirmation": "是否確定要退出？",
    "discardYes": "是",
    "discardStay": "返回",
    "create_team_toast_title": "創建團隊",
    "edit_team": "編輯團隊",
    "team_edits_submitted": "您的團隊已更新。",
    "challenge_ended_still_trackable": "此%{type}已結束，幸運的是，您還有剩下%{num}天可追蹤！",
    "tracking_period_ended": "此%{type}的追蹤期已結束。",
    "unlimited": "無限制",
    "ends_in": "結束於",
    "challenge_toast": {
        "success": {
            "join": "成功！",
            "message": "您已成功加入挑戰。"
        },
        "danger": {
            "error": "錯誤",
            "message": "出錯了。過一會兒再試著加入挑戰。"
        }
    },
    "members_to_invite": "要邀請的成員",
    "members_to_remove": "要移除的成員",
    "myChallenges": "競爭",
    "upcoming": "即將到來",
    "myPersonalGoals": "目標",
    "companyCompetitions": "公司競爭",
    "communityCompetitions": "社群競爭",
    "edit_your_team": "編輯您的團隊",
    "emails": "電郵",
    "CompletedOverall": "整體已完成",
    "TotalEarned": "總計獲得",
    "notify_header": "我想要收到通知：",
    "AdditionalBonus": "額外獎勵",
    "goalEndedNotification": "目標已結束，繼續鞭策自己！",
    "compEndedNotification": "競爭已結束，繼續鞭策自己！",
    "congrats_tracking_first": "恭喜您追蹤到了您的第一項活動！",
    "keep_tracking": "繼續追蹤您的活動，以達成目標，順利晉級。",
    "understanding_tracking": "瞭解追蹤",
    "cannot_track_this_day": "您無法在此日追蹤。",
    "nothing_tracked_this_day": "您還沒有追蹤此日。",
    "tracked_something_this_day": "您為此日追蹤到了一些東西。",
    "reached_goal_this_day": "您已達成此日目標（僅限每日目標）。",
    "got_it": "做到了！",
    "notDismissedMultiTitle": "挑戰總結",
    "notDismissedMultiSubtitle": "有一些挑戰已經結束。深入瞭解每個挑戰，具體看看您是如何做到的。",
    "daySummary": "%{userName}，以下是您目前為止一天的總結",
    "goals": "目標",
    "competitions": "競爭",
    "totalAccumulated": "累計總數",
    "tracking_for_date": "%{date}追蹤",
    "activity_tracker_instruction": "輕觸以編輯或刪除手動追蹤的活動",
    "ended": "已結束",
    "notYetAvailableBeta": "公測版中還沒有",
    "suggestedGoal": "建議目標",
    "singleFor": "為",
    "seeLessLongComment": "查看更少",
    "synced_data": "同步的資料：",
    "doThisLater": "稍後再進行此操作",
    "inviteUsers": "邀請他人加入",
    "cannotTrackAfterDeadline": "您正在嘗試為挑戰截止日期後的一個日期追蹤活動。",
    "potentialBonusPoints": {
        "section": {
            "title": "此目標可獲得%{potentialBonusPoints}獎勵%{customPoints}！",
            "titleNotCompleted": "您錯過了{activitytCompletedPercentage}%的%{potentialBonusPoints}獎勵 %{customPoints}。",
            "titleCompleted": "恭喜！您已獲得",
            "titleCompletedBold": "%{potentialBonusPoints}獎勵%{customPoints}！",
            "subtitle": "瞭解有關獎勵%{customPoints}的更多資訊"
        },
        "modal": {
            "title": "獎勵%{customPoints}",
            "desc1": "我們知道，人無完人，無法100%地每次都完成他們的目標。",
            "desc2": "這就是為什麼我們在您整體進度達到85%或以上時授予獎勵{customPoints}。",
            "desc3": "全部獎勵%{customPoints}在目標結束後授予，如果您的全部追蹤都來自於連接的應用程式或裝置，您將收到雙倍獎勵%{customPoints}！",
            "desc4": "對於您提前離開的目標，您將無法獲得獎勵%{customPoints}。"
        },
        "msg": {
            "title": "此目標已結束",
            "subtitle": "目標結束於%{goalEndedDate}"
        },
        "msgEnded": {
            "title": "時間到！您的目標已結束",
            "subtitle": "您有%{daysNum} %{daysOrDay}可以追蹤您的活動。"
        }
    },
    "finish": "結束",
    "personalGoal": {
        "all_goals": {
            "selected": "全部%{maxGoals}目標已設定！",
            "description": "您喜歡這個嗎？如果您改變主意，您可以替換掉任意目標。別擔心，您稍後還可以取消設定您的目標。",
            "set": "全部目標均已設定！",
            "action": "全部准備好了，可以開始了！",
            "error": "我們還不能得意忘形！一次專注於最多3個結構化目標可以提高您的成功幾率。",
            "errorHeading": "設定目標"
        },
        "set_more": "您可以再設定%{maxGoals}個活躍目標",
        "select_goal": {
            "heading": "設定推薦目標，或自創一個"
        },
        "set_more_1": "您可以再設定1個活躍目標"
    },
    "restartPersonalGoal": "用新目標重啟目標",
    "delete_challenge_confirmation": "是否確定要刪除此挑戰？",
    "personal_goal_unit": "目標",
    "personal_goal_units": "目標",
    "day_summary": {
        "steps_taken": "採用的步驟",
        "calories_in": "攝入卡路里",
        "calories_out": "消耗卡路里",
        "avg_daily": "每日平均",
        "most_earned_daily": "一天獲得最多"
    },
    "invitedBy": "邀請人：%{person}",
    "resetPasswordMissingField": "請輸入電郵",
    "resetPasswordInvalidValue": "請輸入有效的電子郵箱",
    "resetPasswordNotFound": "無法找到您的電郵",
    "resetPasswordNotCompleted": "您的申請無法完成",
    "resetGoalInstructions": {
        "start": "進行%{quantity} %{units} %{activity}",
        "additional": "，%{quantity} %{units} %{activity}",
        "end": "%{frequency}並獲得%{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "已設定一個目標。查看",
        "two": "已設定兩個目標。查看",
        "three": "已設定三個目標。查看",
        "none": "沒有設定目標。設定目標"
    },
    "searchCommunitiesEmpty": "沒有找到社群",
    "searchCommunitiesPlaceholder": "搜尋社群",
    "updating": "更新中……",
    "pts_tracked": "追蹤%{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "再接再厲，您就要提高您的健康得分了。",
    "progressHistory": "進展歷史",
    "privateCommunity": "這是私密社群",
    "do_combo_of_activities": "進行以下任意組合。",
    "noActivitiesTracked": "沒有追蹤到活動",
    "trackingWithFollowingApps": "用以下應用程式\/裝置追蹤",
    "recommendedApps": "此%{challengeType}推薦的應用程式\/裝置",
    "collapseWord": "折疊",
    "started": "已開始",
    "ends": "結束",
    "do_activities": "進行活動",
    "rewards_placeholder": "商店的示例獎勵，佔位符。用戶將看到他們可以購買的各個產品和%{rewardName}花費。",
    "personalGoals": {
        "top": {
            "label": "頂部"
        },
        "allGoals": "全部目標",
        "seeMoreCard": {
            "heading": "沒看到您要找的內容？",
            "description": "看看全部推薦目標",
            "button": "探索目標"
        }
    },
    "rewardsNotAvailable": "這一公測版暫時沒有提供獎勵。在提供後，您將可以在目錄中看到它和完成兌換。",
    "editProfileProvideRestingHeartRate": "請提供至少40的有效靜止心率值",
    "liveBetterHealthInfo": "我們運營著多個計畫，並且擁有各種健康內容專門用於支援廣泛的健康需求和幫助您改善健康。我們的計畫暫時還沒有覆蓋到每種健康狀況和需求——我們還在致力於此！——但是，如果您能回答以下問題，我們將會在看到有益於您的任何健康計畫或服務時聯絡您和\/或向您發送基於證據的資訊，幫助您更好地理解和管理您的健康需求。請注意，我們不會使用這些資訊來評估您的保單的適當性。如果您想知道您的承保範圍，或對您的保單有任何疑問，您可以致電132 331聯絡我們的客戶聯繫團隊。",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已刪除目標"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "您已刪除挑戰"
        }
    },
    "invitations": "邀請",
    "learnMorePeriods": "瞭解有關時期的更多資訊",
    "tracked_by_app_name": "用%{app_name}追蹤",
    "device_required": {
        "text": "此%{challengeType}要求用到應用程式或裝置",
        "button": "連接應用程式或裝置"
    },
    "editingCommunityToast": {
        "success": {
            "title": "編輯社群",
            "message": "社群已編輯"
        }
    },
    "competition": "競爭",
    "close": "關閉",
    "only_automatic_activities_with_device": "此%{goal_or_competition}的活動將透過您已連接的應用程式\/裝置自動追蹤。",
    "only_automatic_activity_with_device": "此%{goal_or_competition}的活動將透過您已連接的應用程式\/裝置自動追蹤。",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "社群已刪除"
        }
    },
    "teamSizeMessage": "您的團隊需要至少%{min}人才能獲取挑戰%{customPoints}。",
    "captain": "隊長",
    "inviteOthersToTeam": "邀請他人加入我的團隊",
    "loadingMetrics": "正在連接來源以更新您的一天……",
    "aboutTeamSize": {
        "title": "團隊規模",
        "text": "%{min}到%{max}"
    },
    "pointsOverview": "%{customPoints}概覽",
    "deepLinks": {
        "requestCouldNotBeCompleted": "您的申請無法完成",
        "error": "錯誤"
    },
    "required_lc": "必填",
    "personal": "個人詳情",
    "biometrics": "生物特徵",
    "makeSelection": "進行選擇",
    "ask_question_success_msg": "謝謝。我們將會盡快回答。",
    "report_issue_success_msg": "謝謝。我們將會盡快回答。",
    "ask_question_success_title": "問題已提交",
    "report_issue_success_title": "技術問題已提交",
    "ask_question_failure_msg": "糟糕……提交您的問題時出錯了，請重試。",
    "report_issue_failure_msg": "糟糕……報告您的問題時出錯了，請重試。",
    "notTrackedActivities": "您沒有為此時期追蹤到任何活動",
    "learn": "瞭解",
    "Balance": "餘額",
    "details": "詳情",
    "Reward": "獎勵",
    "levelsReset": "等級將在%{remainingDays}天內重置",
    "redeem": "兌換",
    "redeemAt": "用%{points}兌換",
    "needPointsToRedeem": "您需要再多%{points}的%{rewardName}。",
    "learnEarnMore": "瞭解如何獲取更多",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "加入團隊",
            "message": "您已成功加入團隊！"
        },
        "danger": {
            "message": "我們遇到了錯誤，無法找到團隊。它可能不存在了。"
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "操作不可用",
            "message": "您的申請無法完成。"
        }
    },
    "transactionLog": "交易",
    "orderHistory": "訂單",
    "pointsAvailableToEarn": "可獲取%{points}",
    "missedYTD": "年初至今錯過的%{missed}",
    "rewardsDetails": "獎勵",
    "successfullyRedeemedItem": "您已成功兌換此物品",
    "orderNumber": "訂單號",
    "amountSpent": "花費金額",
    "status": "狀態",
    "dateRedeemed": "兌換日期",
    "additionalInformation": "額外資訊",
    "shipToAddress": "運送到此地址",
    "pointMissedYearToDate": "今年錯過的%{rewardCurrencyName}",
    "pointMissedYearToDateDescription": "如果您在一個時期結束前沒有達到一個等級，則您本可以獲得的關聯的%{rewardCurrencyName}就視為已錯過。",
    "NoLibraryContentToast": {
        "info": {
            "title": "未找到文章",
            "message": "無法找到文章。可能已被刪除或不再提供。"
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "未找到社群",
            "message": "無法找到社群。可能已被刪除或不再提供。"
        }
    },
    "shippingAddress": "運送 \/ 帳單地址",
    "enterShippingAddress": "輸入您的運送 \/ 帳單地址",
    "streetLine": "街道行%{num}",
    "stateProvince": "所在州\/所在省",
    "postcodePostalcodeZip": "郵遞區號\/郵政編碼\/郵編",
    "phoneNumber": "電話號碼",
    "order": "順序",
    "redemptionConfirmation": "兌換確認",
    "edit": "編輯",
    "processing": "處理中",
    "checkIsYouFirst": "我們只需要先看看是否是您",
    "discardSomeGoals": "我們設定了一些目標。如您繼續，這些目標將被捨棄。",
    "settingGoalsToast": {
        "success": {
            "message": "您的新目標已設定！"
        }
    },
    "one_team": "1個團隊",
    "noAchievementsToEarnMessage": "看起來這一時期已經沒有徽章可以獲取%{rewardCurrencyName}了。",
    "shopRewards": "購買獎勵",
    "validateShippingAddressToast": {
        "danger": {
            "title": "運送 \/ 帳單地址",
            "message": "請填寫完全部字段再繼續。"
        }
    },
    "viewDetails": "查看詳情",
    "potential": "潛力",
    "missed": "已錯過",
    "rewardsStoreNotAvailable": "您在那時無法使用獎勵商店。",
    "havent_tracked_in_a_while_date": "%{currentDate}沒有追蹤到的活動",
    "challengeNotFoundToast": {
        "danger": {
            "title": "挑戰未找到",
            "message": "無法找到挑戰。可能已被刪除或不再提供。"
        }
    },
    "shareYourDaySubtitleActivity": "為此活動添加圖片或說些什麼！",
    "goal_ended": "目標已結束",
    "challenge_ended": "挑戰已結束",
    "day_remaining_to_track": "您有1天可以追蹤任何錯過的活動",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal}結束於%{endDate}",
    "goalEndedModal": {
        "title": "追上被遺忘的活動",
        "message": "在個人目標或挑戰結束後，您在結束日期後將有三天的時間去追蹤您可能遺忘了的任何活動。在此寬限期之後，您將無法追蹤任何可以計入目標或挑戰的額外的活動。"
    },
    "summary": "總結",
    "placedRank": "您位於%{total}第%{rank}",
    "rank": {
        "first": "1",
        "second": "2",
        "third": "3",
        "n": "%{rank}"
    },
    "event_name": "活動名稱",
    "this_is": "這是一個",
    "location_info": "地點和資訊",
    "what_event": "這個活動關於什麼",
    "event_is": "此活動是",
    "start_on": "開始於：",
    "end_on": "結束於：",
    "location": "所在地點",
    "chooseLeaderboard": "選擇一個排行榜",
    "filterOneOfFollowing": "篩選以下一項",
    "showChallengeInstead": "顯示挑戰",
    "showActivityInstead": "顯示活動",
    "showAll": "顯示全部",
    "activitiesShowSame": "活動：%{activityName}",
    "challengeShowSame": "挑戰：%{challengeName}",
    "chooseTimePeriod": "選擇一個時期",
    "youCanFilterOneAtTime": "一次可以選擇一個篩選條件",
    "saveHealthTopicsToast": {
        "success": {
            "message": "健康話題已保存",
            "title": "成功！"
        },
        "info": {
            "message": "無法保存"
        },
        "danger": {
            "title": "出錯了！"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "健康目標已保存",
            "title": "成功！"
        },
        "info": {
            "message": "無法保存"
        },
        "danger": {
            "title": "出錯了！"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "興趣已保存",
            "title": "成功！"
        },
        "info": {
            "message": "無法保存"
        },
        "danger": {
            "title": "出錯了！"
        }
    },
    "edit_event": "編輯活動",
    "leave": "離開",
    "delete_event": "刪除活動",
    "no_events": "無活動",
    "no_events_placeholder": "您目前沒有規劃參加任何未來活動。何不加入一個呢？",
    "event": "活動",
    "challenge": "挑戰",
    "invited_you": "邀請了您",
    "public": "公開",
    "private": "私密",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "活動已成功刪除。"
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "您已離開活動"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "活動已成功上傳。"
        }
    },
    "createEventToast": {
        "success": {
            "message": "活動已成功創建。",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "您嘗試查看的內容當前不可見。它可能被作者刪除了，或者被標記為不適當。",
    "start_time": "開始時間",
    "end_time": "結束時間",
    "event_type": "%{eventType}活動",
    "leave_event_modal": {
        "title": "如果您離開此活動",
        "message": "它將被刪除"
    },
    "leave_event ": "是否確定要離開此活動？",
    "create_event": "創建活動",
    "created_by": "創建人",
    "eventActionToast": {
        "danger": {
            "title": "錯誤",
            "message": "出錯了。"
        }
    },
    "continue": "繼續",
    "wantExitTour": "是否確定要退出導覽？",
    "exitTour": "退出導覽",
    "deleveEventPopup": "是否確定要刪除本活動？",
    "attendeesTitle": "參加者",
    "userEvents": "%{name}的活動",
    "createEventIndicator": "活動創建中",
    "inviteToEvent": "邀請加入活動",
    "noDescription": "沒有描述。",
    "leaderboardIsEmpty": "此排行榜為空，或者，您可能需要在選定時期內追蹤活動才能查看它",
    "notParticipantingInAnyChallenges": "您當前沒有參與任何挑戰",
    "buttonLeaveEvent": "離開活動",
    "leaveEvent ": "離開%{name}？",
    "canceledCreatingChallenge": "創建%{challengeType}已成功取消",
    "swipeReadNotification": "閱讀",
    "productTour": {
        "initialScreen": {
            "title": "歡迎來到%{programName}！",
            "body": "讓我們進行一個導覽，以便讓您很快就能瞭解基本資訊。"
        },
        "dashboard": {
            "title": "儀表板",
            "body": "查看您有多少%{pointsName}以及您邁向各級的進展。然後看看排行榜以瞭解您自己的對戰情況。"
        },
        "rewards": {
            "title": "獎勵",
            "body": "查看您有多少%{rewardPointName}，並在商店兌換它們。"
        },
        "goals": {
            "title": "目標和挑戰",
            "body": "您活躍的個人目標、與他人的挑戰以及特殊任務都可以在這裡找到。"
        },
        "explore": {
            "title": "探索",
            "body": "找到與他人的挑戰，加入社群討論您的興趣，在健康資料庫裡發現新文章。"
        },
        "me": {
            "title": "我",
            "body": "在此處找到您的健康得分，查看您的統計資料，編輯您的個人資料和設定。"
        },
        "finishScreen": {
            "title": "您都準備好了",
            "body": "感謝您完成本導覽。",
            "button": "讓我們開始吧"
        },
        "skip": {
            "title": "是否確定要跳過導覽？",
            "body": "這將結束導覽，您可以立即開始。"
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "認證失敗",
            "message": "無法繼續獎勵兌換。在與獎勵提供商進行認證時出現錯誤。"
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "兌換失敗",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "在您開始之前",
    "disclamerSectionMessage": "在開始任何新的健身計畫或改變生活方式之前諮詢您的醫療保健專業人士，以確保它們適合於您。",
    "noEarchedAchievements": "您還沒有獲得任何成就。追蹤活動以開始。",
    "noInProgressAchievements": "您沒有成就在進展中。",
    "discardCreatingEventMessage": "查看全部必填字段已輸入",
    "discardCreatingEventTitle": "活動無法創建",
    "discardEditedEventTitle": "活動無法編輯",
    "errorEventNameMessage": "名稱必填",
    "errorEventStartDateMessage": "開始日期必填",
    "errorEventEndDateMessage": "結束日期必填",
    "errorEventDateMessage": "結束日期不得早於開始日期",
    "noAccountsToLink": "沒有帳戶可連結到%{program_name}。",
    "accountLinkEmailChanged": "您的電子郵箱已更新。以後請用您連結的帳戶登入。",
    "accountLinkSuccessful": "您的帳戶已成功連結。",
    "edit_profile_nan_value": "值必須是數字",
    "advancedLogIn": "高級登入",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "兌換失敗",
            "message": "訂單會話已過期。請重新下訂單。"
        }
    },
    "left": "離開",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "看起來目前沒有活動可供加入。何不自己創建一個？"
        }
    },
    "reachedHighestLevel": "您已達到最高級！",
    "error": "錯誤",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "獎勵兌換",
            "message": "您已下單"
        }
    },
    "redeemRewardComplete": "兌換完成",
    "trackActivityTitle": {
        "oneUnit": "追蹤：%{date}，1 %{unit} %{activity}",
        "nUnit": "追蹤：%{date}，%{activity}"
    },
    "ssoAuthenticationFailure": "認證失敗",
    "earnEvery": "每隔%{frequency}獲取",
    "earnOnce": "僅獲取一次",
    "goalSettings": {
        "maximumSet": "您目前的設定已達到3個目標的上限。",
        "learnMore": "瞭解有關目標設定的更多資訊"
    },
    "allowMarketingComms": "向我發送促銷性的通訊",
    "allowPartnerMarketingComms": "向我發送來自合作夥伴的促銷性的通訊",
    "noUpcomingAchievements": "您沒有即將取得的成就。",
    "settingGoalToast": {
        "success": {
            "message": "您的新目標已設定！"
        }
    },
    "authentication": {
        "saml": {
            "error": "服務目前不可用",
            "signin": "集成登入",
            "signup": "集成報名"
        }
    },
    "monthName": {
        "january": "一月",
        "february": "二月",
        "march": "三月",
        "april": "四月",
        "may": "五月",
        "june": "六月",
        "july": "七月",
        "august": "八月",
        "september": "九月",
        "october": "十月",
        "november": "十一月",
        "december": "十二月"
    },
    "promotedForMe": "特點",
    "appRating": {
        "enjoying": "喜歡我們的應用程式？",
        "feedback": "您有回饋意見想提供給我們嗎？",
        "appStore": "在App Store中評價我們？",
        "googlePlay": "在Google Play中評價我們？",
        "notReally": "並不",
        "yes": "是的！",
        "sure": "當然",
        "noThanks": "不，謝謝",
        "notNow": "不是現在"
    },
    "getMobileApp": "要在您的智慧型手機上使用%{programName}，請從App Store或Google Play下載%{appStoreName}。",
    "newAppsDevicesDesign": {
        "getMobileApp": "下載%{programName}應用程式",
        "searchInAppStore": "在您的裝置的應用程式商店中搜尋%{programName}",
        "getMobileAppNoName": "獲取行動應用程式"
    },
    "editorAlert": {
        "discardChanges": "捨棄更改",
        "saveAndContinue": "保存並繼續",
        "title": "未保存的更改",
        "text": "您進行了一些更改，更改尚未保存。您想要做什麼？"
    },
    "resources": "資源",
    "noResources": "無資源可用",
    "viewAllResources": "查看全部資源",
    "language": "語言",
    "eventStarted": "活動已開始。註冊已關閉。",
    "Gender": "性別",
    "show": "顯示",
    "hide": "隱藏",
    "timeoutError": "啊哦！反應時間過長。請稍後重試。",
    "SOT": {
        "sample_task": "樣例任務"
    },
    "cache": {
        "new_version": "新版本可用！",
        "refresh_browser": "點擊此處，刷新您的瀏覽器。"
    },
    "welcomeUser": "歡迎，%{userFirstName}！",
    "quarter": "季",
    "completionReward": "完成獎勵",
    "bronzeLevel": "青銅級",
    "deviceAppSyncingOk": "裝置 \/ 應用程式同步OK",
    "deviceAppSyncingIssue": "裝置 \/ 應用程式同步問題",
    "deviceAppSyncingError": "裝置 \/ 應用程式同步錯誤",
    "lastSync": "最近同步",
    "period": "時期",
    "yourDaySummary": "到目前為止，您的一天",
    "steps": "步",
    "gender_non_binary": "非二元或非常规",
    "take_survey": "進行調查",
    "social": "社交",
    "finalDay": "最後一天",
    "leaderboard_position": "排行榜位次",
    "signUp": {
        "apple": {
            "disconnectSettings": "在iPhone設定『Apple ID密碼和安全』下取消連接%{appName}以繼續註冊"
        }
    },
    "earnPoints": "獲取%{customPoints}。晉級。",
    "getReward": "獲取%{rewardName}。",
    "buildHealthyHabits": "建立健康的習慣。",
    "highestLevelIndicator": "您已達到最高級！",
    "highestLevelIndicatorNew": "您已完成每個等級！",
    "trackYourActivity": "要獲取%{customPoints}，請追蹤您的運動和健康活動。",
    "levelUpToGetRewarded": "在您晉級後，您將獲得%{rewardName}獎勵。",
    "levelUpAndEarn": "您的進展每隔%{period}重置一次，因此，您可以一再升級和獲取積分。",
    "levelUp": "您的進展每隔%{period}重置一次，因此，您可以一再升級。",
    "goToLibrary": "前往資料庫",
    "updateEventIndicator": "活動更新中",
    "meTour": {
        "healthSurveyDisabled": "在此處查看您的統計資料，編輯您的個人資料和設定。"
    },
    "createNewGoal": "創建新目標",
    "later": "稍後",
    "bonusChallenge": "獎勵性挑戰",
    "bonusChallengeInfo": {
        "withReward": "完成此{challengeType}的至少85%，您將獲得%{amount}獎勵%{points}。",
        "noReward": "完成此挑戰的至少85%，您將獲得獎勵。",
        "boldText": "%{amount}獎勵%{points}",
        "noRewardChallengeType": "完成此%{challengeType}的至少85%，您將獲得獎勵。"
    },
    "defaultApp": "您的默認健康應用程式",
    "bonusGoal": {
        "additionalInfo": "如果您的全部活動都透過已連接的應用程式或裝置追蹤，您將獲得雙倍獎勵%{points}！",
        "additionalInfoNew": {
            "paragraph2": "獎勵%{points}將在目標結束後授予。對於您提前離開的目標，您將無法獲得獎勵%{points}。"
        },
        "boldText": "雙倍獎勵%{points}！",
        "markTitle": "獎勵目標"
    },
    "notify_me": "通知我",
    "bonusChallengeReward": "獎勵性挑戰的獎勵",
    "forCompletingChallenge": "針對完成%{challengeName}",
    "notifications_text": "通知可以幫助您堅守目標，及時對話。",
    "type_here": "在此處鍵入",
    "bonusEarned": "已獲得的獎勵",
    "youEarnedBonus": "您獲得了此獎勵！",
    "inviteOthersToChallenge": "邀請他人加入挑戰",
    "inviteOthersToYourTeam": "邀請他人加入您的團隊",
    "manageTeam": "管理團隊",
    "ft": "英呎",
    "lbs": "磅",
    "cm": "釐米",
    "kg": "千克",
    "community": "社群",
    "chooseActivity": "選擇活動",
    "Recent": "最近",
    "noActivities": "無匹配活動",
    "photoChooseText": "選擇",
    "photoCancelText": "取消",
    "signIn": {
        "missingEmail": "缺少電子郵箱",
        "missingPassword": "請確保提供密碼",
        "invalidLogin": "無效登入",
        "accountLocked": "您的帳戶已鎖定。請聯絡您的管理員",
        "accountMayNotExist": "此電子郵箱在我們這裡沒有帳戶。註冊以創建帳戶。",
        "wrongPassword": "錯誤密碼。重試，或點擊「忘記密碼」重設密碼。"
    },
    "deleteGoalBonusPoints": "如果您還沒有拿下關聯的獎勵，您將無法再獲得此獎勵。",
    "havent_tracked_goal": "您還沒有為此目標追蹤到任何活動",
    "trackActivity": {
        "search": "搜尋活動……",
        "text": "追蹤活動",
        "done": "完成",
        "discardChanges": "捨棄更改？",
        "discardMessage": "是否確定要退出和捨棄您的進展？",
        "discard": "捨棄",
        "limitMessage": "您一次只能追蹤最多七天。",
        "inputDescription": "%{date}的%{activity}數量",
        "gracePeriod": "您有%{n} %{text}可以追蹤任何錯過的活動"
    },
    "dates": "日期",
    "pickDates": "挑選其他日期",
    "selectDates": "選擇日期",
    "limitReached": "您已達到限制",
    "activity": "活動",
    "keepUpTheGoodWork": "再接再厲！",
    "activityTracked": "已追蹤到的活動",
    "new": "最新",
    "newFeatureTitle": "更簡單和快速的活動追蹤",
    "newFeatureText": "無論您是從今天開始還是在過去就追蹤過活動，也不論您是否要追蹤多天的活動，我們的新體驗一定會深得您的喜愛。",
    "gotIt": "做到了！",
    "frequencyViewHistory": "查看%{frequency}明細",
    "challengeDetails": {
        "trackTheseActivities": "追蹤其中任意活動，向此%{challengeType}邁進。"
    },
    "member": "會員",
    "weeklyBreakdown": "每週明細",
    "setGoals": {
        "earnPointsText": {
            "start": "獲得",
            "end": "設定您的第一個目標！"
        }
    },
    "weeklyGoalEnded": "一週結束於",
    "weekFinished": "您結束了___________的一週",
    "restartGoal": {
        "daysLeftToTrack": "您還有%{quantity} %{days}可以追蹤上週遺忘的任何進展。",
        "weekEnded": "本週已結束。",
        "timesUp": "時間到！",
        "period": {
            "title": "目標時期",
            "text": "週一到週日，每週"
        }
    },
    "membersPlural": "成員",
    "startedADayAgo": "於1天前開始",
    "goalRestarted": "您重啟了此目標",
    "weeklyGoals": "每週目標",
    "weeklyGoalsDescription": "每週目標將在每週一重新開始，從而幫助您長期保持健康的習慣。",
    "challengeEnded": "此%{challengeType}已結束",
    "goalEndedModalTitle": "時間到！您的%{challengeType}已結束！",
    "yourProgress": "您的進展",
    "earn_withRewards": "跟踪您的健康活动以获得 (%{pts}) 并通过级别。当您升级时，您将获得%{currency}。",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "當期",
    "currentScore": "當前得分",
    "viewActivityLog": "查看活動日誌",
    "balanceHistory": "我的餘額歷史",
    "mymedibank": {
        "underAge": {
            "error": "「讓生活更美好」（Live Better）應用程式僅限18歲及以上用戶使用，請參見Live Better條款和條件瞭解更多資訊。"
        }
    },
    "enhancedHomePageInfo": "我們整理了一下首頁！現在，您可以更容易地查看您的挑戰和目標。是時候進行追蹤了！",
    "levelUpTitle": "晉級",
    "levelUpDescription": "透過追蹤活動和完成目標以及挑戰的方式過關斬將。在您晉級後，您將獲得%{currency}獎勵！",
    "achievementsDescription": "解鎖這些特別徽章，獲取%{currency}。點擊徽章查看您需要做些什麼。",
    "bonusChallengesDescription": "加入並完成提供%{currency}獎勵的挑戰。",
    "earnWithPartners": {
        "title": "透過合作夥伴獲取",
        "description": "擁有醫院或附加保險的Medibank會員可以透過前往合作夥伴處進行合格的購物\/活動賺取積分。"
    },
    "browseAllPartners": "瀏覽全部合作夥伴",
    "resetsIn": "在%{daysNumber}天內重置",
    "thisIsALot": "這可太多了！",
    "areYouSure": "您確定嗎？",
    "trackingALotMessage": {
        "days": "您在%{daysNum}天內追蹤了超過2,000 %{customPoints}。這真的很多！",
        "day": "您在1天內追蹤了超過2,000 %{customPoints}。這真的很多！"
    },
    "amSure": "我確定",
    "activeMinutesAndSleep": {
        "title": "追蹤活動分鐘數和睡眠的裝置",
        "description": "您的裝置會記錄您在中等或高強度的體能活動中的活動分鐘數——這是優質鍛煉！使用裝置追蹤您的睡眠？您也將因此獲得%{points}！"
    },
    "hourShort": "小時",
    "hoursShort": "小時",
    "secondsShort": "秒",
    "watchToEarn": "觀看以獲取",
    "oneParticipant": "1個參與者",
    "oneTeam": "1個團隊",
    "numberOfTeams": "%{num}個團隊",
    "inviteToYourTeam": "邀請加入您的團隊",
    "inviteToThisChallenge": "邀請加入此挑戰",
    "challengeInstructionText": "追蹤此活動以為您的%{challengeType}累計進展。",
    "showLess": "顯示更少",
    "startsTomorrow": "明天開始",
    "deadlineDayLeft": "剩餘天",
    "deadlineDaysLeft": "剩餘天數",
    "deviceBonus": "裝置獎勵",
    "appsAndDevices": {
        "header": "應用程式和裝置",
        "linked": "已連結的這些應用程式和裝置正在為此%{challengeType}進行追蹤：",
        "noLinked": "無已連結的可用應用程式或裝置",
        "link": "連結您的手機、手錶或應用程式以自動追蹤。"
    },
    "yourGoals": "您的目標",
    "yourChallenges": "您的挑戰",
    "position": "位次",
    "team_success": "團隊成功",
    "starts_in": "於______開始",
    "team_challenge": "團隊挑戰",
    "your_progress_today": "您今日的進展",
    "your_daily_avarage": "您的每日平均是",
    "this_week_progress": "本週進展",
    "this_month_progress": "本月進展",
    "overall_progress": "整體進展",
    "complete": "完成",
    "overallSuccess": "整體成功",
    "teamSuccessAverage": "團隊成功平均",
    "progressDetails": "進展詳情",
    "dayStreak": "連續%{n}天成就！",
    "weekStreak": "連續%{n}週成就！",
    "dailyProgress": "每日進展",
    "participantsSuccessCount": {
        "overall": "%{total}參與者中有%{amount}達成目標",
        "day": "%{total}參與者中有%{amount}今天達成了目標",
        "week": "%{total}參與者中有%{amount}本週達成了目標",
        "month": "%{total}參與者中有%{amount}本月達成了目標"
    },
    "doubleBonusShort": "雙倍獎勵！",
    "doubleBonusLong": "您獲得了雙倍獎勵！",
    "recommendedGoalDescription": "目標有助於您追蹤您的進展和保持充足的動力！",
    "noParticipation": "無參與",
    "nothingToShow": "看起來目前沒有什麼可顯示的",
    "yourTeam": "您的團隊",
    "no_activity_title": "無活動",
    "brandSupport": {
        "description": "我們為Polar和Withings智慧手錶添加了活動同步的支援。是時候動起來了！"
    },
    "no_tracked_activities": "您還沒有追蹤任何活動。",
    "button_leave_community": "離開社群",
    "button_delete_challenge": "刪除%{challengeType}",
    "button_delete_community": "刪除社群",
    "button_delete_activity": "刪除活動",
    "library_header_description": "用於教育、吸引參與和激勵啟發您的健康之旅的原創內容。",
    "library_searchbar": "搜尋資料庫……",
    "library_page_header": "用於教育、吸引參與和激勵啟發您的健康之旅的原創內容。",
    "onboarding_button_title": "完成了",
    "refresh_bar": "點擊此處進行更新",
    "content": {
        "min_read": "已讀%{readingTime}分鐘"
    },
    "noMembers": "無成員",
    "saved": "已保存",
    "forYou": "為您",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction}透過",
    "youCanEarnThisBadge": "每隔%{period}，您就能獲得此徽章一次",
    "emailPreferences": "電郵偏好",
    "unsubscribeText": "選擇退出所有電郵更新",
    "savingText": "保存中……",
    "wrongTryLater": "出錯了。請稍後重試。",
    "preferencesSaved": "偏好已保存",
    "recommendedForYou": "為您推薦",
    "formerMember": {
        "label": "前成員"
    },
    "selectionsFromLibrary": "我們從資料庫中專門為您挑選的精選",
    "goalsInfo": {
        "desc1": "用於助力您專注改善您的健康",
        "desc2": "您設定的目標已達到最大數量。"
    },
    "createMyOwn": "自行創建",
    "isAllSet": "都設定好了！",
    "undoLabel": "撤銷操作",
    "terms": "條款",
    "placeOrder": "下單",
    "item": "項",
    "redeemFor": "選擇兌換",
    "confirmYourOrder": "確認您的訂單",
    "orderComplete": "訂單完成",
    "redeemedFor": "兌換",
    "orderDetails": "訂單詳情",
    "bonusGoalReward": "獎勵目標獎勵",
    "orderSummary": "訂單摘要",
    "logoutSSO": {
        "title": "您已登出%{programName}。",
        "description": "期待很快再次見到您！",
        "signinAgain": "點擊此處再次登入"
    },
    "nothing_to_show": "目前沒有可顯示的內容",
    "no_saved_content": "您沒有任何已保存的內容",
    "restarts_every_week": "每週重新開始",
    "myGoals": "我的目標",
    "goalGallery": "目標圖庫",
    "share_smth": "分享一些東西……",
    "newFeatureModal": {
        "smartGoal": {
            "title": "我們的分步目標變得更智慧了！",
            "description": "您的每週各不相同——現在，您的目標也是這樣！\n 在智慧模式下，您的分步目標將根據您的實際活動自行調整。\n 它是為您的成功和健康而設的。",
            "action": "來看看！"
        },
        "mePage": {
            "title": "全新的「我」",
            "description": "我們重新設計了「我」的這一部分，以便讓您可以更輕鬆地找到您關心的一切——來看看吧！",
            "letsSeeBtn": "讓我們看一看！",
            "llaterBtn": "以後再說"
        },
        "bellEAP": {
            "title": "歡迎來到您的員工和家庭援助計畫線上平台！",
            "description": "來看看這裡有哪些工具和服務可以為您以及您符合資格的家人提供健康以及生活挑戰上的支援",
            "button": "現在就連接，或隨時訪問快速連結頁面"
        },
        "quickActivityLogView": {
            "title": " 更快捷地查看您最近的活动",
            "description": "您现在可以单击进度条来查看您的活动日志。"
        }
    },
    "goalSmartMode": {
        "title": "智慧模式",
        "description": "獲得根據您最近的活動水平個人化的每週目標。",
        "status": "此目標的智慧模式已%{status}。",
        "infoModal": {
            "descriptionOne": "在智慧模式開啟後，此目標的各目標將會根據您最近的活動水平每週變更。",
            "descriptionTwo": "我們只會對您提起適量的挑戰，以便您取得成功。",
            "instructions": ""
        },
        "settings": {
            "switch": "為我的分步目標開啟智慧模式",
            "description": "在智慧模式開啟後，您將在每週初始收到新的分步目標。"
        },
        "enableSmartMode": "開啟智慧模式",
        "settingsModal": {
            "descriptionTurnOn": "您的分步目標的各目標將會根據您的活動每週變更",
            "descriptionTurnOff": "您的分步目標的各目標將不再每週個人化"
        }
    },
    "On": "開啟",
    "Off": "關閉",
    "top_posts": "熱門貼文",
    "most_recent": "最近",
    "browseByTopic": "按話題瀏覽",
    "video": "影片",
    "enable": "啟用",
    "turnOff": "關閉",
    "new_post": "新貼文",
    "new_post_in": "________新貼文",
    "dailyTarget": "每日目標",
    "dailyTargetForWeek": "週每日目標",
    "showMyActivityLog": "顯示我的活動日誌",
    "usersReacted": {
        "oneOther": "%{userName}和1個其他人",
        "multipleOthers": "%{userName}和%{count}個其他人"
    },
    "reactionsModal": {
        "title": "更多慶祝方式",
        "description": "用全新的社交貼文反應表情為您的同事加油鼓勁！"
    },
    "account": "帳戶",
    "myWellbeingProfile": "我的健康資料",
    "physicalDetailsDescription": "需要用此資訊計算您的健康得分",
    "wellbeingInterests": "健康興趣",
    "myWellbeingInterests": "我的健康興趣",
    "preferredNameOptional": "偏好名稱（可選）",
    "basicPhysicalDetails": "基本身體詳情",
    "notRegistered": {
        "infoModal": {
            "title": "我們無法找到您",
            "notInSystem": "不在我們的系統中。",
            "correctEmail": "請務必使用正確的帳戶（通常是公司電子郵箱）並查看是否有錯別字。",
            "emailHelp": "如想獲得更多幫助，請發送電郵聯絡我們的支援團隊"
        }
    },
    "dontHaveAccount": "沒有帳戶？",
    "wasThisHelpful": "這對您有幫助嗎？",
    "healthScoreFeedbackModal": {
        "emojiSection": "本頁面和您的健康得分的幫助作用有多大？",
        "commentSectionText": "我們可以如何改進它們？",
        "commentSectionPlaceholder": "添加評論……",
        "thankYouModal": "感謝您的回饋意見！"
    },
    "number_connected": "已連接%{numDevices}",
    "searchPlaceHolder": "搜尋……",
    "noTeamsFound": "未找到團隊",
    "join_a_challenge": "加入挑戰",
    "me_page_titles": {
        "goal": {
            "singular": "目標",
            "plural": "目標"
        },
        "challenge": {
            "singular": "挑戰",
            "plural": "挑戰"
        }
    },
    "seeMoreText": "……查看更多",
    "adjust_entry": "請調整輸入。",
    "overTracking": {
        "title": "過度追蹤警告",
        "desc1": {
            "singular": "此輸入將被審核。",
            "plural": "這些輸入將被審核。"
        },
        "desc2": "故意過度追蹤可能導致帳戶被吊銷。",
        "button_edit": "編輯我的輸入",
        "button_confirm": "照樣提交"
    },
    "oneEventAttendee": "1個參加者",
    "multipleEventAttendees": "%{num}個參加者",
    "to": "至",
    "eventBonusFull": "參加此活動，您將獲得%{number} bonus %{points}。",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "您喜歡這篇文章嗎？",
    "didYouLikeVideo": "您喜歡這個影片嗎？",
    "tellUsMore": "告訴我們更多……",
    "thanksForFeedback": "感謝您的回饋意見！",
    "challengesSubtitle": "與其他參與者一起達到目標——或在遊戲中致勝！",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health健康",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health虛擬護理",
    "virtualCare": "虛擬護理",
    "changePassword": {
        "telus": {
            "info": "您的密碼透過您的%{telusVC}帳戶管理。",
            "button": "更改我的%{virtualCare}密碼"
        }
    },
    "actions": "行動",
    "onAndUpcoming": "目前和即將到來的",
    "termsAndPrivacyPolicyNew": "繼續即代表您同意",
    "invitedToTeam": "獲邀加入%{firstName} %{lastName}的團隊",
    "decline": "拒絕",
    "invitedToChallenge": "邀請人%{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "您還沒有設定任何目標"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "您沒有參加任何挑戰",
        "buttonLabel": "探索挑戰"
    },
    "menu": "菜單",
    "everyone": "每個人",
    "confirmEmployeeID": "確認員工ID",
    "employeeIDNoMatch": "這些ID還不匹配",
    "hidePost": "隱藏%{ownerName}的貼文",
    "hidingUserPostToast": {
        "success": {
            "title": "用戶已隱藏",
            "message": "您不會再看到這個用戶的貼文。"
        }
    },
    "moderateHideUserDescription": "為此用戶隱藏貼文將會從流中撤掉用戶特定內容。",
    "startsInOneDay": "1天後開始",
    "endsInOneDay": "1天後結束",
    "endsToday": "今日結束",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "不在我們的系統中。您的輸入是否正確？",
            "administrator": "如果您是新員工，我們可能還沒有您的員工ID。請詢問您的管理員，瞭解您應該何時重試一次。",
            "emailNotInSystem": "如果您是新員工，您的電子郵箱可能還沒添加到我們的系統。請詢問您的管理員，瞭解您應該何時重試一次。",
            "eligibleEmail": "不是合格的電子郵箱。您的輸入是否正確？"
        }
    },
    "oneMember": "1個成員",
    "programCode": {
        "infoModal": {
            "unique": "您的公司擁有唯一的計畫代碼，通常會透過電郵提供給您。",
            "support": "如果您無法找到您的代碼，請聯絡您的健康計畫管理員，或發送帶您的公司名稱的電郵給support@sproutatwork.com。"
        },
        "instructions": "輸入由您的僱主提供的計畫代碼以開始"
    },
    "whatsMyProgramCode": "我的計畫代碼是什麼？",
    "enjoyApp": "享用我們的行動應用程式",
    "programCodeLabel": "計畫代碼",
    "createdByMembersChallenges": "由成員創建",
    "invites": "邀請",
    "recommendedContentTitle": "專門給您的資料庫精選",
    "amountExchanged": "兌換金額",
    "orderStatus": "訂單狀態",
    "orderSuccessfulyyItemForConfirmation": "下單成功！確認已發送到%{email}。",
    "orderedOnDateText": "於%{orderCreatedTime}下單",
    "personalize": {
        "communities": {
            "title": "加入社群",
            "description": "社群將擁有共同興趣的人們聯繫在一起。您可以隨時加入或離開社群。"
        },
        "objectives": {
            "title": "我的目標",
            "description": "我們可以幫助您開始或保持住什麼？我們將用此改進我們的推薦。"
        },
        "topics": {
            "title": "我的健康話題",
            "description": "您會看到有關您選擇的話題的更多提示和方法指導。"
        }
    },
    "recommendedCardDesc": "設定最多3個目標以專注於改善您的健康",
    "accessibility": {
        "track_activity": "追蹤活動",
        "cardbody": "卡片正文",
        "cardcontainer": "卡片容器",
        "cardfooter": "卡片腳註",
        "unstartedChallengeHeader": "未開始的挑戰",
        "activeOrEndedChallengeWrapper": "挑戰包裝",
        "activeOrEndedChallengeHeader": "挑戰標題",
        "goalHeader": "目標標題",
        "openOptions": "開放選項"
    },
    "teams": {
        "teamInvites": "團隊邀請",
        "findTeam": "找到團隊",
        "teamFull": "團隊已滿員"
    },
    "deleteAccountText": "永久刪除您的Sprout At Work帳戶及其全部資料",
    "deleteAccountButtonTitle": "刪除我的帳戶",
    "joinTeamActionSheetText": "加入或創建團隊以參加此挑戰",
    "frequencyNone": "無",
    "quickLinkTitle": "快速連結",
    "moreTab": "更多",
    "addedBy": "添加人%{companyName}",
    "teamsTitle": "團隊",
    "helpAndSupport": "應用程式幫助與支援",
    "feedbackTitle": "給出回饋意見",
    "feedbackDescription": "告訴我們您喜歡這個應用程式的哪些部分以及我們可以在哪裡進行改進。",
    "leaveTeamAction": "離開團隊",
    "teamActions": "團隊行動",
    "leaveTeamLeaveChallenge": "離開此團隊意味著離開挑戰。您需要加入團隊才能繼續參與。",
    "familyMembers": "家人",
    "familyMembersDescription": "家人必須年滿16歲。他們將對整個平台擁有完整的訪問權限，全平台的內容都對他們可見。",
    "learnMoreButton": "瞭解更多",
    "thvcSelection": {
        "signUpUsingTelus": "用您的Telus Health虛擬護理帳戶註冊",
        "loginGetStarted": "登入虛擬護理以開始",
        "haveAccount": "您是否有虛擬護理帳戶？",
        "emailHelp": "需要幫忙嗎？歡迎聯絡我們的支援團隊",
        "yes": "是",
        "signMeUp": "不，我要註冊"
    },
    "inviteFamilyMember": {
        "label": "邀請家人",
        "btn": "發送邀請",
        "email": "電子郵箱*",
        "firstName": "名字*",
        "lastName": "姓氏*",
        "approval": "我確認我已獲准邀請此家人至%{company}",
        "multiSelect1": "此家人在您所在地區是否已經達到成年年齡？",
        "multiSelect2": "此家人是否至少16歲？",
        "confirmTermsPolicy": "我確認我是此人的法定監護人。在我看來，受撫養人已足夠成熟，能夠同意平台的使用，並且我同意他們加入平台。我將向受撫養人說明，他們在平台上的行為需要是負責任的行為，並將向他們解釋平台收集和使用他們資料的方式。",
        "onTheirBehalf": "代表他們。",
        "confirm": "是，我確認上述內容",
        "warning": "家人必須至少年滿16歲才能註冊",
        "errorMsg": "在嘗試繼續之前，請查看錯誤"
    },
    "deleteFamilyMember": {
        "desc": "刪除家人的帳戶屬於永久性的操作。",
        "btn": "刪除家人",
        "confirmation": {
            "title": "已刪除家人",
            "desc": "%{fullName}的帳戶已刪除"
        },
        "areYouSure": "確定要刪除%{fullName}的帳戶嗎？"
    },
    "familyInvitationStatus": {
        "active": "活躍",
        "sent": "邀請已發送"
    },
    "familyInvitationSent": {
        "title": "邀請電郵已發送",
        "desc": "邀請已發送給%{fullName}"
    },
    "programCodeSignup": "在使用%{programCodeLabel} %{programCode}之前，先點擊'%{signUpLabel}'",
    "notJoinedCommunityLabel": "加入本社群，查看成員們分享的內容",
    "moda": {
        "installApp": {
            "title": "請注意：Moda Health 會員只能透過其會員儀表板存取 Sprout at Work。",
            "subtitle": "要在智慧型手機上使用 Sprout at Work：",
            "stepOneA": "1. 安裝Sprout at Work行動應用程式。",
            "stepOneB": "請勿在行動應用程式上註冊或登入。",
            "stepTwo": "2. 用手機登入會員控制面板",
            "stepThree": "3. 瀏覽 Sprout 健康計劃並按照該連結 - 它將打開 Sprout at Work 行動應用程式。"
        }
    },
    "HRISLocationSelection": {
        "title": "您在哪個國家工作？"
    },
    "visibilitySettings": {
        "title": "可见性设置",
        "desc1": "您公司中的其他 Wellbeing 应用成员可以看到吗？",
        "desc2": "您以后可以随时更改此设置。",
        "moreTextQ1": "其他人能看到什么？",
        "moreTextAnswer1": "公司中的人员可以看到您的姓名、个人资料照片和基本个人资料详细信息（例如部门和地点）。这使得该应用程序更具社交性和乐趣。",
        "moreTextQ2": "我会出现在哪里？",
        "moreTextAnswer2": "您将在排行榜和搜索结果中显示为您加入的挑战、社区和活动的参与者。您可以稍后调整。",
        "moreTextAnswer3": "我们不会分享或显示您的个人健康信息，例如您的身高、体重或您跟踪的活动。",
        "btnAgree": "给我看一下就可以了",
        "btnDisagree": "不要让其他成员看到我"
    },
    "privacyPolicyReadMore": "要了解更多信息，请阅读我们的隐私政策",
    "tellMeMore": "告诉我更多",
    "helpUsImprove": {
        "title": "帮助我们改进",
        "desc1": "我们使用记录匿名使用数据的工具。了解人们查看和点击内容的趋势有助于我们改进应用程序。",
        "desc2": "您可以随时将其关闭。",
        "moreTextQ1": "我们看什么",
        "moreTextAnswer1": "我们对总体趋势和统计数据感兴趣，因此我们不会查看个人层面的数据。",
        "moreTextQ2": "我们不会分享您的数据",
        "moreTextAnswer2": "这些数据仅供构建此应用程序的人员使用，以帮助改进该应用程序。我们不会与其他公司（包括您的雇主）分享。",
        "moreTextQ3": "您的数据是匿名的",
        "moreTextAnswer3": "我们的工具不会记录您的姓名、确切位置或任何个人健康信息。",
        "btnAgree": "匿名跟踪我的使用情况",
        "btnDisagree": "我不同意跟踪"
    },
    "deleteAccountTextAppName": "",
    "anonymousMember": "匿名会员",
    "activitiesToTrack": {
        "title": "要跟踪的活动"
    },
    "includedInMembership": "包含在您的會員資格中",
    "invalidDate": "失效日期",
    "discardsStreamPost": {
        "discardTitle": "放弃帖子？",
        "discardChangesTitle": "放弃更改？",
        "discardPostText": "您确定要放弃您的帖子吗？",
        "discardPostChangesText": "您确定要放弃更改吗？"
    },
    "trackActivityModalTitle": "跟踪%{日期}",
    "noPosts": "没有帖子可看",
    "goalIcon": "目标图标",
    "resetsOn": "于 %{date} 重置",
    "clickForHelp": "单击此处获取帮助",
    "trackActivityInputLabel": "输入 %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "找到的物品",
    "tagState": {
        "active": "积极的",
        "notActive": "不活跃"
    },
    "bonusCheckmarkLabel": "因完成任务而获得 %{bonusLabel} 奖励积分",
    "searchBar": {
        "searching": "搜索 %{term}",
        "result": "搜索结果"
    },
    "activityProgress": "活动进度 - %{levelName} %{percentFilled}% - %{daysLeft} 天后重置",
    "bookmark": {
        "remove": "从保存的项目中删除",
        "save": "保存该项目"
    },
    "bonusMark": {
        "earn": "赚取 %{数量} %{积分}",
        "earned": "您获得了 %{qty} %{points}"
    },
    "tabToTrackActivity": "点击以跟踪活动",
    "videoElementLabel": "%{title}，时长%{duration}，双击播放视频",
    "updatedPoliciesPopup": {
        "title": "我們更新了條款",
        "details": "我們鼓勵您閱讀以下更新後的政策：",
        "disclaimer": "點擊下面的按鈕即表示您同意並確認更新的政策。",
        "agree": "我同意"
    },
    "editActivityLog": {
        "canNotEditItem": "您无法编辑此条目",
        "canNotEditItemDescription": "编辑不适用于从设备或应用程序同步的活动。",
        "updatedItem": "活动已更新",
        "updatedItemDescription": "您的更改已保存。"
    },
    "login_with_email": "使用電子郵件登入",
    "healthconnect_not_available": "無法連線到 Health Connect。在 Health Connect 應用程式中，請確保已啟用權限。",
    "registrationField": {
        "required": {
            "firstName": "請輸入您的名字",
            "lastName": "請輸入您的姓氏",
            "email": "請輸入有效的電子郵件地址",
            "password": "請輸入有效密碼"
        }
    },
    "settingsErrorMessage": {
        "firstName": "请输入您的名字",
        "lastName": "请输入您的姓氏"
    },
    "requiredValidValue": "请为您的 %{value} 输入有效值",
    "passwordHidden": "密码已隐藏，点击即可显示密码",
    "passwordShown": "显示密码，点击隐藏密码",
    "libraryHeaderContent": {
        "category": "",
        "points": "赚取 %{point} 积分。"
    },
    "scoreCurrentPeriod": "%{text} 是从 %{startDate} 到 %{endDate}",
    "scoreCurrent": "%{text} 是 %{points} 点",
    "abbotResetPasswordModal": {
        "title": "您是否正在尝试访问去年的帐户？",
        "text": " 如果您报名参加了去年的挑战，则该帐户将不再有效。今年你需要报名。",
        "goToResetPasswordBtn": "我在 %{currentYear} 注册",
        "goToSignupBtn": "我尚未在 %{currentYear} 注册"
    },
    "challengeRegistrationClosed": "報名已結束 - 挑戰賽已開始",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit 即將停用",
            "description": "切換到 Health Connect 以繼續自動追蹤您的活動.",
            "linkBtn": "切換到 Health Connect"
        },
        "newFeatureModal": {
            "label": "需要採取行動",
            "title": "Google Fit 不再支援活動同步",
            "web": {
                "doNotHaveApp": "還沒有我們的應用程式？",
                "getAppText": "在此下載",
                "dateNotIncludedDescription": "請使用您的智慧型手機切換到 Google's Health Connect.",
                "dateIncludedDescription": "我們將在 %{date} 移除 Google Fit 整合。請使用您的智慧型手機切換到 Google's Health Connect"
            },
            "mobile": {
                "dateNotIncludedDescription": "切換到 Health Connect 以繼續自動追蹤您的活動.",
                "dateIncludedDescription": "我們將在 %{date} 移除 Google Fit 整合。切換到 Health Connect 以繼續自動追蹤您的活動.",
                "buttonLabel": "切換到 Health Connect"
            }
        }
    }
};